(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hardstone-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hardstone-hero')){
customElements.define('hardstone-hero',class extends HTMLElement{
connectedCallback(){
 if(this.controller)return;
 this.controller=new AbortController();
 const signal=this.controller.signal;
 this.track=this.querySelector('.hs-hero__track');
 this.slides=[...this.querySelectorAll('.hs-hero__slide')];
 if(!this.track||!this.slides.length)return;
 this.dots=[...this.querySelectorAll('[data-slide-index]')];
 this.pause=this.querySelector('[data-pause]');
 this.desktop=matchMedia('(min-width:750px)');
 this.reduced=matchMedia('(prefers-reduced-motion:reduce)');
 this.index=0;this.stopped=false;this.hovered=false;this.inView=true;
 this.fadeEffects=[];this.visibleRatio=0;this.introReady=false;this.introDone=false;
 this.classList.toggle('hs-hero--fade',!this.desktop.matches);
 try{this.introDone=sessionStorage.getItem('hs-hero-intro-v2')==='1';}catch{}
 const firstImage=this.slides[0].querySelector('img');
 const ready=()=>{
  this.introReady=true;
  const nextImage=this.slides[1]?.querySelector('img');
  if(nextImage&&!this.desktop.matches){nextImage.loading='eager';nextImage.fetchPriority='low';}
  this.scheduleIntro();
 };
 if(firstImage?.complete&&firstImage.naturalWidth)ready();
 else firstImage?.addEventListener('load',ready,{once:true,signal});
 this.addEventListener('pointerdown',()=>this.cancelIntro(true),{passive:true,signal});
 this.addEventListener('keydown',()=>this.cancelIntro(true),{signal});
 window.addEventListener('scroll',()=>this.cancelIntro(true),{passive:true,signal});
 this.querySelector('.hs-hero__nav')?.toggleAttribute('hidden',this.slides.length<2);
 this.addEventListener('click',e=>{
  const dot=e.target.closest('[data-slide-index]');
  const step=e.target.closest('[data-step]');
  if(dot){this.stop();this.go(Number(dot.dataset.slideIndex));}
  if(step){this.stop();this.go(this.index+Number(step.dataset.step));}
  if(e.target.closest('[data-pause]')){this.stopped=!this.stopped;this.schedule();this.pauseState();}
 },{signal});
 this.addEventListener('keydown',e=>{
  if(e.target.matches('input,textarea,select'))return;
  if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.stop();this.go(this.index+(e.key==='ArrowRight'?1:-1));}
 },{signal});
 this.track.addEventListener('pointerdown',event=>{
  this.stop();
  if(!this.desktop.matches&&event.isPrimary&&event.button===0&&!event.target.closest('a,button'))
   this.swipe={id:event.pointerId,x:event.clientX,y:event.clientY};
 },{passive:true,signal});
 this.track.addEventListener('pointerup',event=>{
  const start=this.swipe;this.swipe=null;
  if(!start||start.id!==event.pointerId||this.desktop.matches)return;
  const dx=event.clientX-start.x,dy=event.clientY-start.y;
  if(Math.abs(dx)>=40&&Math.abs(dx)>Math.abs(dy)*1.3)this.go(this.index+(dx<0?1:-1));
 },{passive:true,signal});
 this.track.addEventListener('pointercancel',()=>{this.swipe=null;},{passive:true,signal});
 this.track.addEventListener('scroll',()=>{
  if(!this.desktop.matches)return;
  cancelAnimationFrame(this.frame);
  this.frame=requestAnimationFrame(()=>this.activate(Math.round(this.track.scrollLeft/this.track.clientWidth)));
 },{passive:true,signal});
 this.addEventListener('mouseenter',()=>{this.hovered=true;this.schedule();},{signal});
 this.addEventListener('mouseleave',()=>{this.hovered=false;this.schedule();},{signal});
 this.addEventListener('focusin',()=>this.schedule(),{signal});
 this.addEventListener('focusout',()=>queueMicrotask(()=>{if(!signal.aborted)this.schedule();}),{signal});
 document.addEventListener('visibilitychange',()=>{if(document.hidden)this.cancelIntro(true);this.schedule();},{signal});
 this.desktop.addEventListener('change',()=>{
  this.cancelIntro(true);this.finishTransition();
  this.classList.toggle('hs-hero--fade',!this.desktop.matches);
  this.track.scrollTo({left:this.desktop.matches?this.index*this.track.clientWidth:0,behavior:'instant'});
  this.schedule();
 },{signal});
 this.reduced.addEventListener('change',()=>{if(this.reduced.matches){this.cancelCopyMotion();this.finishTransition();this.cancelIntro(true);}this.schedule();},{signal});
 this.resize=new ResizeObserver(()=>{if(this.desktop.matches)this.track.scrollTo({left:this.index*this.track.clientWidth,behavior:'instant'});});
 this.resize.observe(this.track);
 this.visibility=new IntersectionObserver(entries=>{
  this.inView=entries[0].isIntersecting;this.visibleRatio=entries[0].intersectionRatio;
  if(this.visibleRatio<.6)this.cancelIntro(false);else this.scheduleIntro();
  this.schedule();
 },{threshold:[0,.6]});
 this.visibility.observe(this);
 document.addEventListener('shopify:block:select',e=>{
  const index=this.slides.findIndex(slide=>slide.dataset.blockId===e.detail.blockId);
  if(index>=0){this.stop();this.go(index);}
 },{signal});
 this.activate(0);this.pauseState();this.schedule();
}
scheduleIntro(){
 if(this.introDone||this.introTimer||!this.introReady||this.visibleRatio<.6||this.desktop.matches||this.reduced.matches||this.slides.length<2||this.index!==0||this.stopped||document.hidden||window.Shopify?.designMode)return;
 this.dataset.introRunning='true';
 this.introTimer=setTimeout(()=>{
  this.introTimer=null;
  delete this.dataset.introRunning;
  const image=this.slides[1].querySelector('img');
  if(this.introDone||!this.isConnected||this.visibleRatio<.6||this.desktop.matches||this.reduced.matches||this.stopped||this.index!==0||document.hidden||!image?.complete||!image.naturalWidth)return;
  this.introDone=true;
  try{sessionStorage.setItem('hs-hero-intro-v2','1');}catch{}
  this.go(1);
 },6000);
}
cancelIntro(permanent){
 clearTimeout(this.introTimer);this.introTimer=null;delete this.dataset.introRunning;
 if(permanent)this.introDone=true;
}
finishTransition(){
 (this.fadeEffects||[]).forEach(effect=>effect.cancel());this.fadeEffects=[];
 this.slides?.forEach(slide=>slide.classList.remove('is-leaving'));
}
activate(index){
 const changed=!this.hasActivated||index!==this.index;
 const initial=!this.hasActivated;
 this.hasActivated=true;
 this.index=Math.max(0,Math.min(this.slides.length-1,index));
 this.slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===this.index);slide.inert=i!==this.index;slide.setAttribute('aria-hidden',String(i!==this.index));});
 this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===this.index)));
 const status=this.querySelector('[data-status]');
 if(status)status.textContent=this.slides[this.index].dataset.title;
 if(changed&&!initial)this.revealCopy();
}
cancelCopyMotion(){(this.copyEffects||[]).forEach(effect=>effect.cancel());this.copyEffects=[];}
revealCopy(){
 this.cancelCopyMotion();
 if(this.reduced.matches)return;
 const copy=this.slides[this.index].querySelector('.hs-hero__copy');
 if(!copy)return;
 this.copyEffects=[copy.animate([{opacity:0},{opacity:1}],{
  duration:360,delay:this.desktop.matches?0:160,easing:'cubic-bezier(.22,1,.36,1)',fill:'backwards'
 })];
}
go(index){
 this.cancelIntro(true);
 const next=(index+this.slides.length)%this.slides.length;
 if(next===this.index)return;
 if(this.slides.some(slide=>slide.contains(document.activeElement)))this.dots[next]?.focus({preventScroll:true});
 if(this.desktop.matches){
  this.track.scrollTo({left:next*this.track.clientWidth,behavior:this.reduced.matches?'instant':'smooth'});
  return;
 }
 this.finishTransition();
 const previous=this.slides[this.index];
 this.activate(next);
 if(this.reduced.matches)return;
 previous.classList.add('is-leaving');
 const fade=previous.animate([{opacity:1},{opacity:0}],{duration:720,easing:'cubic-bezier(.4,0,.2,1)',fill:'forwards'});
 this.fadeEffects.push(fade);
 const oldCopy=previous.querySelector('.hs-hero__copy');
 if(oldCopy)this.fadeEffects.push(oldCopy.animate([{opacity:1},{opacity:0}],{duration:140,fill:'forwards'}));
 fade.finished.then(()=>{if(this.fadeEffects.includes(fade))this.finishTransition();}).catch(()=>{});
}
stop(){this.cancelIntro(true);this.querySelector('[data-status]')?.setAttribute('aria-live','polite');this.stopped=true;this.schedule();this.pauseState();}
pauseState(){
 if(!this.pause)return;
 this.pause.setAttribute('aria-label',this.stopped?this.pause.dataset.playLabel:this.pause.dataset.pauseLabel);
 this.pause.querySelector('[data-pause-icon]').hidden=this.stopped;
 this.pause.querySelector('[data-play-icon]').hidden=!this.stopped;
}
schedule(){
 clearTimeout(this.timer);
 const allowed=this.dataset.autoplay==='true'&&this.desktop.matches&&!this.reduced.matches&&this.slides.length>1;
 if(this.pause)this.pause.hidden=!allowed;
 if(!allowed||this.stopped||this.hovered||document.hidden||!this.inView||this.contains(document.activeElement)||window.Shopify?.designMode)return;
 this.timer=setTimeout(()=>{this.go(this.index+1);this.schedule();},6500);
}
disconnectedCallback(){this.cancelIntro(true);this.finishTransition();this.cancelCopyMotion();this.controller?.abort();this.controller=null;clearTimeout(this.timer);cancelAnimationFrame(this.frame);this.resize?.disconnect();this.visibility?.disconnect();}
});
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-announcements"]) return;
  try {
    
if (!customElements.get('hs-ann-init')) {
  customElements.define('hs-ann-init', class extends HTMLElement {});
  const start = (root) => {
    if (root.dataset.annInit) return;
    root.dataset.annInit = '1';
    const slides = [...root.querySelectorAll('[data-ann-slide]')];
    const track = root.querySelector('[data-ann-track]');
    if (slides.length < 2) { if (track) track.remove(); return; }
    const DUR = 10000;
    track.innerHTML = slides.map(() => '<i><b></b></i>').join('');
    const segs = [...track.children];
    let i = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));
    let timer = 0, anim = null, paused = false, visible = true;
    const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
    const fit = () => slides.forEach((s) => {
      s.style.fontSize = '';
      let f = parseFloat(getComputedStyle(s).fontSize);
      while (s.scrollWidth > s.clientWidth + 1 && f > 10.5) { f -= .25; s.style.fontSize = f + 'px'; }
    });
    fit();
    if ('ResizeObserver' in window) new ResizeObserver(fit).observe(root);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    const paint = () => segs.forEach((s, j) => s.classList.toggle('is-done', j < i));
    const show = (n, dir) => {
      root.dataset.dir = dir || 'next';
      const prev = slides[i];
      prev.classList.remove('is-active'); prev.classList.add('is-leaving');
      setTimeout(() => prev.classList.remove('is-leaving'), 650);
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
    };
    const run = () => {
      clearTimeout(timer); anim && anim.cancel();
      paint();
      const fill = segs[i].firstChild;
      if (!reduced() && fill.animate) anim = fill.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration: DUR, easing: 'linear', fill: 'forwards' });
      else fill.style.transform = 'scaleX(1)';
      timer = setTimeout(() => { if (paused || !visible || document.hidden) { run(); return; } show(i + 1); run(); }, DUR);
    };
    const hold = (v) => { paused = v; if (anim) { v ? anim.pause() : anim.play(); } };
    root.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') hold(true); });
    root.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') hold(false); });
    root.addEventListener('focusin', () => hold(true));
    root.addEventListener('focusout', () => hold(false));
    /* dokunuş sıradakine geçer; yana kaydırma ileri / geri; dikey kaydırma sayfaya kalır (touch-action: pan-y) */
    let x0 = null, swiped = 0;
    root.addEventListener('pointerdown', (e) => { x0 = e.clientX; });
    root.addEventListener('pointerup', (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 30) { swiped = performance.now(); dx < 0 ? show(i + 1, 'next') : show(i - 1, 'back'); run(); }
    });
    root.addEventListener('pointercancel', () => { x0 = null; });
    root.addEventListener('click', () => { if (performance.now() - swiped < 400) return; show(i + 1, 'next'); run(); });
    root.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { show(i + 1, 'next'); run(); } else if (e.key === 'ArrowLeft') { show(i - 1, 'back'); run(); } });
    if ('IntersectionObserver' in window) new IntersectionObserver((es) => { visible = es.some((e) => e.isIntersecting); }).observe(root);
    run();
  };
  const init = () => document.querySelectorAll('[data-hs-ann]').forEach(start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-combination-pilot"]) return;
  try {
    
function createCombinationEngine(config) {
  const profiles = new Map(config.profiles.map(p => [Number(p.id), p]));
  for (const override of config.profileOverrides || []) {
    if (!override.id || !override.role || !override.family) continue;
    const previous = profiles.get(Number(override.id)) || {};
    profiles.set(Number(override.id), {...previous, ...override, confidence: 'merchant_review'});
  }
  const profile = id => profiles.get(Number(id));
  const isHead = p => ['cap', 'beanie'].includes(p.role);
  const isGear = p => ['cap', 'beanie', 'belt', 'bag'].includes(p.role);
  const isPlain = p => p.family === 'solid';
  const covers = p => p?.covers || (p ? [isHead(p) ? 'head' : p.role === 'bib' ? 'bottom' : p.role] : []);
  const configuredGroups = (config.families || []).map(f => ({name: f.name, bundle: f.products.find(p => p.role === 'bundle')?.id, ids: f.products.map(p => Number(p.id))}));
  const groups = [...configuredGroups];
  for (const p of profiles.values()) {
    if (p.role === 'outfit' && p.components?.length && !groups.some(g => g.bundle === p.id)) groups.push({name: '', bundle: p.id, ids: [p.id, ...p.components]});
  }
  const sharedGroup = (a, b) => groups.find(g => g.ids.includes(a.id) && g.ids.includes(b.id));
  const idsInCart = cart => {
    const ids = new Set();
    const visit = item => {
      const id = Number(item.product_id);
      if (id) ids.add(id);
      for (const component of item.item_components || []) visit(component);
      for (const componentId of profile(id)?.components || []) ids.add(Number(componentId));
    };
    for (const item of cart?.items || []) visit(item);
    return ids;
  };
  const occupiedSlots = (cart, sourceId) => {
    const result = new Set();
    for (const id of idsInCart(cart)) for (const slot of covers(profile(id))) result.add(slot);
    for (const slot of covers(profile(sourceId))) result.add(slot);
    return result;
  };
  const priorities = source => {
    if (source.role === 'base') return source.thermal === 'hot' ? ['bottom', 'vest', 'cap'] : ['bottom', 'vest', 'mid', 'cap', 'beanie'];
    if (source.role === 'mid') return ['bottom', 'vest', 'base', 'beanie', 'cap'];
    if (source.role === 'outer') return ['bottom', 'mid', 'base', 'beanie', 'cap'];
    if (source.role === 'vest') return source.thermal === 'warm' ? ['bottom', 'mid', 'base', 'beanie', 'cap'] : ['bottom', 'base', 'mid', 'cap', 'beanie'];
    if (source.role === 'bottom') return source.style === 'casual' ? ['base', 'mid', 'cap', 'beanie'] : ['base', 'vest', 'mid', 'cap', 'beanie'];
    if (source.role === 'bib') return ['mid', 'base', 'outer', 'beanie', 'cap'];
    if (source.role === 'outfit') {
      if (covers(source).includes('vest')) return ['bottom', 'beanie', 'cap', 'mid'];
      if (covers(source).includes('mid')) return ['base', 'vest', 'beanie', 'cap'];
      return ['mid', 'base', 'beanie', 'cap'];
    }
    if (isHead(source)) return source.thermal === 'warm' ? ['mid', 'bottom', 'base', 'vest'] : ['base', 'bottom', 'vest', 'mid'];
    return ['bottom', 'base', 'vest', 'mid'];
  };
  const pair = (source, target) => {
    if (!source || !target || source.id === target.id || target.role === 'outfit' || target.role === 'bib') return null;
    if (target.confidence === 'pattern_review' || target.family === 'unknown') return null;
    const group = sharedGroup(source, target);
    if (!group) {
      if (source.neon === 0 && target.neon === 2) return null;
      if (source.neon === 2 && target.neon === 0 && !isPlain(target)) return null;
    }
    if (source.thermal === 'hot' && target.thermal === 'warm') return null;
    if (source.role === 'bottom' && source.thermal === 'light' && target.thermal === 'warm') return null;
    if (source.thermal === 'warm' && target.role === 'bottom' && ['hot', 'light'].includes(target.thermal)) return null;
    if (source.thermal === 'warm' && target.role === 'base' && target.thermal === 'hot') return null;
    if (source.style === 'field' && target.style === 'casual' && target.role === 'bottom') return null;
    if (source.style === 'casual' && target.style === 'field' && !['base', 'cap', 'beanie'].includes(target.role)) return null;
    const shared = source.palette.filter(c => target.palette.includes(c));
    const samePattern = source.pattern && source.pattern !== 'solid' && source.pattern === target.pattern;
    const sameFamily = source.family !== 'unknown' && source.family === target.family;
    const forest = new Set(['oak', 'woodland', 'branch']);
    const forestMatch = forest.has(source.family) && forest.has(target.family) && shared.length >= 2;
    const plainMatch = isPlain(source) || isPlain(target);
    if (!group && !samePattern && !sameFamily && !forestMatch && !plainMatch) return null;
    if (!group && !shared.length && !plainMatch) return null;
    if (!group && !plainMatch && Math.abs(source.brightness - target.brightness) > 1) return null;
    if (source.family === 'unknown' && !isPlain(target)) return null;
    if (plainMatch && !shared.length && !target.palette.some(c => ['olive', 'black', 'charcoal', 'brown', 'tan'].includes(c))) return null;
    let score = group ? (isGear(source) ? 32 : 105) : 0;
    let reason = group ? 'reason_set' : 'reason_plain';
    if (samePattern) { score += 64; if (!group) reason = 'reason_pattern'; }
    else if (sameFamily && !isPlain(source)) { score += 42; if (!group) reason = 'reason_family'; }
    else if (forestMatch) { score += 28; if (!group) reason = 'reason_tones'; }
    else if (plainMatch) score += isPlain(source) && isPlain(target) ? 48 : 30;
    score += Math.min(shared.length, 3) * 9;
    if (source.palette[0] === target.palette[0]) score += 12;
    if (!shared.length && plainMatch) score += 8;
    score -= Math.abs(source.brightness - target.brightness) * 5;
    if (source.thermal === target.thermal || target.thermal === 'flex') score += 7;
    if (source.line && source.line === target.line) score += 10;
    if (source.neon === 2 && target.neon === 2) score += 8;
    const priority = priorities(source).indexOf(target.role);
    if (priority < 0) return null;
    score += Math.max(6, 36 - priority * 6);
    if (score < 62) return null;
    return {score, reason, group, priority, source};
  };
  const chooseAnchors = (cart, sourceId, placement) => {
    if (placement === 'product') {
      const current = profile(sourceId);
      return current && !current.complete ? [current] : [];
    }
    if ((cart?.items || []).some(item => profile(item.product_id)?.complete)) return [];
    let anchors = [...new Map((cart?.items || []).map(i => profile(i.product_id)).filter(Boolean).filter(p => !p.complete).map(p => [p.id, p])).values()];
    const clothing = anchors.filter(p => !isGear(p));
    if (clothing.length) anchors = clothing;
    const patterned = anchors.filter(p => !isPlain(p) && p.family !== 'unknown');
    if (!patterned.length) return anchors.slice(0, 1);
    const strength = a => patterned.reduce((sum, b) => sum + (a.id === b.id || sharedGroup(a,b) || (a.family === b.family && a.neon === b.neon) ? covers(b).length : 0), 0);
    const dominant = patterned.map((p, index) => ({p, index, score: strength(p)})).sort((a,b) => b.score - a.score || a.index - b.index)[0].p;
    return patterned.filter(p => p.id === dominant.id || sharedGroup(dominant,p) || (p.family === dominant.family && p.neon === dominant.neon));
  };
  const rank = (placement, cart, sourceId, catalog) => {
    const anchors = chooseAnchors(cart, sourceId, placement);
    if (!anchors.length) return [];
    const occupied = idsInCart(cart);
    if (placement === 'product') occupied.add(Number(sourceId));
    const slots = occupiedSlots(cart, placement === 'product' ? sourceId : null);
    if (['base', 'vest', 'bottom', 'head'].every(slot => slots.has(slot))) return [];
    const entries = new Map(catalog.map(p => [Number(p.id), p]));
    const result = [];
    for (const entry of catalog) {
      const target = profile(entry.id);
      if (!target || !entry.available || !(entry.price > 0) || occupied.has(Number(entry.id))) continue;
      if (entry.handle.endsWith('-meta') || entry.proxy || target.role === 'outfit' || target.role === 'bib') continue;
      if (covers(target).some(slot => slots.has(slot))) continue;
      if ((target.role === 'outer' && slots.has('vest')) || (target.role === 'vest' && slots.has('outer'))) continue;
      const options = anchors.map(a => pair(a, target)).filter(Boolean).sort((a,b) => b.score - a.score || a.priority - b.priority);
      if (!options.length) continue;
      const match = options[0];
      const bundleEntry = match.group?.bundle ? entries.get(match.group.bundle) : null;
      const bundle = bundleEntry?.available && bundleEntry.price > 0 && !occupied.has(bundleEntry.id) ? {id:bundleEntry.id, url:bundleEntry.url, title:bundleEntry.title} : null;
      const family = match.group ? (match.group.name || bundleEntry?.title || '') : match.source.family;
      result.push({...entry, role:target.role, family, familyKey:match.source.family, reason:match.reason, score:match.score, priority:match.priority, sourceId:match.source.id, bundle,
        selectionGroup: isHead(target) ? 'head' : ['base','mid'].includes(target.role) ? 'inner' : target.role});
    }
    return result.sort((a,b) => a.priority - b.priority || b.score - a.score || a.id - b.id);
  };
  return {rank, pair, profile, idsInCart, occupiedSlots, chooseAnchors};
}

(() => {
  const configNode = document.getElementById('HsPilotConfig');
  if (!configNode) return;
  const cfg = JSON.parse(configNode.textContent);
  cfg.profiles = JSON.parse(document.getElementById('HsCombinationProfiles')?.textContent || '{"profiles":[]}').profiles;
  cfg.catalog = [];
  const engine = createCombinationEngine(cfg);
  const t = cfg.text;
  const root = cfg.root.endsWith('/') ? cfg.root : cfg.root + '/';
  const cache = new Map();
  let busy = false;
  let uncertain = false;
  let cartState = null;
  let revision = 0;
  const money = value => new Intl.NumberFormat(cfg.locale, { style: 'currency', currency: cfg.currency || 'TRY' }).format(value / 100);
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const text = (key, name) => t[key].replace('[name]', name || '');
  const read = async url => {
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'} });
    if (!response.ok) throw new Error(t.error);
    return response.json();
  };
  const getProduct = async (handle, fresh = false) => {
    if (fresh || !cache.has(handle)) cache.set(handle, read(root + 'products/' + encodeURIComponent(handle) + '.js'));
    try { return await cache.get(handle); } catch (error) { cache.delete(handle); throw error; }
  };
  const getCart = () => read(root + 'cart.js');
  const idsInCart = cart => engine.idsInCart(cart);
  const candidates = (placement, cart) => engine.rank(placement, cart, cfg.productId, cfg.catalog);
  let catalogPromise;
  const loadCatalog = () => {
    if (!cfg.enabled || document.querySelector('hs2-discovery')) return Promise.resolve([]);
    if (catalogPromise) return catalogPromise;
    catalogPromise = (async () => {
      const products = new Map();
      const first = new URL(cfg.catalogUrl, window.location.origin);
      first.searchParams.set('section_id', 'hs-combination-catalog');
      let next = first.href;
      const visited = new Set();
      while (next) {
        const url = new URL(next, first);
        if (url.origin !== first.origin || url.pathname !== first.pathname || visited.has(url.href) || visited.size >= 10) throw new Error(t.error);
        url.searchParams.set('section_id', 'hs-combination-catalog');
        visited.add(url.href);
        const response = await fetch(url.href, {credentials:'same-origin', cache:'no-store', headers:{Accept:'text/html'}});
        if (!response.ok) throw new Error(t.error);
        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const node = documentFragment.querySelector('#HsCombinationCatalog');
        if (!node) throw new Error(t.error);
        const page = JSON.parse(node.textContent);
        if (!Array.isArray(page.products)) throw new Error(t.error);
        for (const product of page.products) products.set(Number(product.id), product);
        next = page.next;
      }
      cfg.catalog = [...products.values()];
      return cfg.catalog;
    })();
    return catalogPromise;
  };
  const track = (name, detail) => {
    const payload = {placement: detail.placement, source_product_id: cfg.productId || null, product_id: detail.id || null, position: detail.position || null, rule: detail.reason || 'reviewed_pattern_v2', family: detail.familyKey || null};
    try {
      document.dispatchEvent(new CustomEvent('hardstone:' + name, {detail: payload}));
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) window.Shopify?.analytics?.publish?.('hardstone_' + name, payload);
    } catch (_) { }
  };
  const selectedRows = panel => panel ? (panel.rows || []).filter(row => row.checked) : [];
  const variantOf = row => row.product.variants.find(v => String(v.id) === String(row.variantId));
  const main = () => document.querySelector('[data-hs-purchase]');
  const mainForm = () => document.getElementById(main()?.dataset.formId);
  const mainVariant = () => cfg.mainVariants.find(v => String(v.id) === String(mainForm()?.querySelector('[name="id"]')?.value));
  const quantity = () => Number(new FormData(mainForm()).get('quantity') || 1);
  const message = (panel, value, kind = 'error') => {
    if (panel) panel.querySelector('[data-hs-status]').textContent = value;
    if (main()) {
      const form = main().querySelector('product-form');
      form?.handleErrorMessage(value || false);
      const feedback = form?.querySelector('.product-form__error-message-wrapper');
      if (feedback) { feedback.dataset.hsFeedback = kind; feedback.setAttribute('role', kind === 'success' ? 'status' : 'alert'); }
    }
  };
  const syncMain = () => {
    const purchase = main();
    if (!purchase) return;
    const panel = purchase.querySelector('hs-pilot-panel');
    const rows = selectedRows(panel);
    const form = mainForm();
    const add = form?.querySelector('[name="add"]');
    const variant = mainVariant();
    const blocked = busy || uncertain || !variant?.available || add?.disabled;
    const label = busy ? t.adding : rows.length ? t.add_selected : (add?.querySelector('span')?.textContent || t.main_only);
    const sticky = document.querySelector('[data-hs-sticky-add]');
    sticky.disabled = Boolean(blocked);
    if (sticky.textContent !== label) sticky.textContent = label;
    purchase.querySelector('[data-hs-checkout]').disabled = Boolean(blocked);
    const amount = (variant?.price || 0) * quantity() + rows.reduce((sum, row) => sum + (variantOf(row)?.price || 0), 0);
    document.querySelector('[data-hs-sticky-price]').textContent = money(amount);
    if (!panel) return;
    const combined = panel.querySelector('[data-hs-combined]');
    combined.hidden = !rows.length;
    panel.querySelector('[data-hs-total]').textContent = money(amount);
    panel.querySelector('[data-hs-add-combination]').disabled = Boolean(blocked || rows.some(row => !variantOf(row)?.available));
  };
  const variantLabel = (product, variant) => {
    const changing = product.options.map((o, i) => ({i, length: o.values.length})).filter(o => o.length > 1).map(o => o.i);
    return (changing.length ? changing.map(i => variant.options[i]).join(' / ') : variant.title === 'Default Title' ? t.available_options : variant.title);
  };
  const renderCard = (row, index, placement) => {
    const p = row.product;
    const v = variantOf(row);
    const reason = row.reason === 'reason_family' ? text('reason_family', t['family_' + row.familyKey]) : t[row.reason] || t.reason_plain;
    const id = 'hs-choice-' + placement + '-' + p.id;
    const image = p.featured_image ? '<a href="' + esc(row.url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=200') + '" alt="" width="86" height="112" loading="lazy"></a>' : '<span></span>';
    const price = v?.price ?? p.price_min;
    const compare = v?.compare_at_price;
    return '<article class="hs-pilot-card" data-hs-card="' + index + '">' + image + '<div><span class="hs-pilot-role">' + esc(t['role_' + row.role] || '') + '</span><p class="hs-pilot-reason">' + esc(reason) + '</p><h3><a href="' + esc(row.url) + '" data-hs-product-link="' + index + '">' + esc(p.title) + '</a></h3><p class="hs-pilot-price">' + esc(money(price)) + (compare > price ? '<s>' + esc(money(compare)) + '</s>' : '') + '</p></div><div class="hs-pilot-options"><label for="' + id + '" class="hs-pilot-select-label">' + esc(t.available_options) + '</label><select id="' + id + '" data-hs-variant="' + index + '"><option value="">' + esc(t.choose) + '</option>' + p.variants.map(option => '<option value="' + option.id + '"' + (!option.available || !(option.price > 0) ? ' disabled' : '') + (String(option.id) === String(row.variantId) ? ' selected' : '') + '>' + esc(variantLabel(p, option)) + (!option.available || !(option.price > 0) ? ' — ' + esc(t.sold_out) : '') + '</option>').join('') + '</select>' + (placement === 'product' ? '<label class="hs-pilot-include"><input type="checkbox" data-hs-include="' + index + '"' + (row.checked ? ' checked' : '') + '>' + esc(t.include) + '</label>' : '<button type="button" data-hs-cart-add="' + index + '"' + (!v?.available || busy || uncertain ? ' disabled' : '') + '>' + esc(t.add_one) + '</button>') + '</div></article>';
  };
  const draw = panel => {
    panel.querySelector('[data-hs-cards]').innerHTML = panel.rows.map((r,i) => renderCard(r,i,panel.dataset.placement)).join('');
    panel.hidden = !panel.rows.length;
    const bundle = panel.rows[0]?.bundle;
    const link = panel.querySelector('[data-hs-set-link]');
    link.hidden = !bundle;
    if (bundle) { link.href = bundle.url; link.textContent = t.set_link; }
    syncMain();
  };
  const loadPanel = async panel => {
    const token = ++panel.loadToken;
    if (!cfg.enabled || !cartState || (panel.dataset.placement === 'cart' && !cartState.item_count)) { panel.hidden = true; panel.rows = []; return; }
    const rows = [];
    const selectionGroups = new Set();
    for (const candidate of candidates(panel.dataset.placement, cartState)) {
      if (rows.length >= 2) break;
      if (selectionGroups.has(candidate.selectionGroup)) continue;
      try {
        const product = await getProduct(candidate.handle);
        if (!product.available || !product.variants.some(v => v.available && v.price > 0) || product.tags.includes('Meta Catalog Proxy') || product.id !== candidate.id) continue;
        const singleHead = ['cap','beanie'].includes(candidate.role) && product.variants.length === 1 && product.variants[0].available;
        rows.push({...candidate, product, checked: false, variantId: singleHead ? String(product.variants[0].id) : ''});
        selectionGroups.add(candidate.selectionGroup);
      } catch (_) { }
    }
    if (token !== panel.loadToken || !panel.isConnected) return;
    panel.rows = rows;
    draw(panel);
    panel.observer?.disconnect();
    panel.observer = new IntersectionObserver(entries => {
      if (entries.some(e => e.isIntersecting)) {
        rows.forEach((r,i) => track('recommendation_viewed', {...r, placement: panel.dataset.placement, position: i+1}));
        panel.observer.disconnect();
      }
    }, {threshold: .25});
    if (rows.length) panel.observer.observe(panel);
  };
  const freeze = value => {
    busy = value;
    document.querySelectorAll('.hs-purchase button, .hs-purchase-sticky button, hs-pilot-panel button, hs-pilot-panel select, hs-pilot-panel input').forEach(el => {
      if (value) { el.dataset.hsWasDisabled = el.disabled ? '1' : '0'; el.disabled = true; }
      else if ('hsWasDisabled' in el.dataset) { el.disabled = el.dataset.hsWasDisabled === '1'; delete el.dataset.hsWasDisabled; }
    });
    syncMain();
  };
  const perform = async (panel, destination, cartRow = null) => {
    if (busy || uncertain) return;
    const form = mainForm();
    const rows = cartRow ? [cartRow] : selectedRows(panel);
    if (!cartRow && (!form || form.querySelector('[name="add"]')?.disabled || !mainVariant()?.available)) { message(panel,t.main_unavailable); return; }
    if (rows.some(row => !variantOf(row)?.available || !(variantOf(row)?.price > 0))) { message(panel,t.missing_size); panel?.querySelector('select')?.focus(); return; }
    if (!cartRow && (!Number.isInteger(quantity()) || quantity() < 1)) { form.reportValidity(); return; }
    if (!cartRow && !form.reportValidity()) return;
    message(panel,'');
    const snapshot = !cartRow ? new FormData(form) : null;
    const beforeVariant = snapshot?.get('id');
    const beforeQuantity = Number(snapshot?.get('quantity') || 1);
    const beforePrice = mainVariant()?.price;
    const purchaseTrigger = document.activeElement;
    let sent = false;
    freeze(true);
    try {
      const freshCart = await getCart();
      const occupied = idsInCart(freshCart);
      const eligible = new Set(candidates(panel?.dataset.placement || 'product', freshCart).map(p => p.id));
      if (rows.some(r => occupied.has(r.id) || !eligible.has(r.id))) {
        cartState = freshCart;
        await loadPanel(panel);
        throw new Error(t.cart_changed);
      }
      let priceChanged = false;
      const extras = [];
      for (const row of rows) {
        const oldPrice = variantOf(row)?.price;
        row.product = await getProduct(row.handle,true);
        const variant = variantOf(row);
        if (!variant?.available || !(variant.price > 0)) { row.variantId = ''; draw(panel); throw new Error(t.stock_changed); }
        if (variant.price !== oldPrice) priceChanged = true;
        extras.push({id: variant.id, quantity: 1});
      }
      let items = extras;
      if (!cartRow) {
        const currentProduct = await getProduct(cfg.productHandle,true);
        const currentVariant = currentProduct.variants.find(v => String(v.id) === String(beforeVariant));
        if (!currentVariant?.available) throw new Error(t.main_unavailable);
        if (String(form.querySelector('[name="id"]').value) !== String(beforeVariant) || quantity() !== beforeQuantity) throw new Error(t.cart_changed);
        const localVariant = mainVariant();
        if (currentVariant.price !== beforePrice) { localVariant.price = currentVariant.price; priceChanged = true; }
        const properties = {};
        for (const [key, value] of new FormData(form).entries()) {
          const match = key.match(/^properties\[(.*)\]$/);
          if (match && typeof value === 'string' && value) properties[match[1]] = value;
        }
        const item = {id: Number(beforeVariant), quantity: beforeQuantity, properties};
        if (snapshot.get('selling_plan')) item.selling_plan = snapshot.get('selling_plan');
        items = [item, ...extras];
      }
      if (priceChanged) { if (panel) draw(panel); throw new Error(t.price_changed); }
      const noteInput = document.querySelector('#Cart-note');
      if (cartRow && noteInput && noteInput.value !== (freshCart.note || '')) {
        const noteResponse = await fetch(root + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:noteInput.value})});
        if (!noteResponse.ok) throw new Error(t.error);
      }
      const drawer = destination !== 'checkout' && !cartRow ? document.querySelector('cart-drawer') : null;
      const payload = {items};
      if (drawer && typeof drawer.renderContents === 'function') {
        payload.sections = ['cart-drawer','cart-icon-bubble'];
        payload.sections_url = cfg.cartUrl;
      }
      sent = true;
      const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});
      const result = await response.json();
      if (!response.ok || result.status) {
        let after;
        try { after = await getCart(); } catch (_) { }
        const fingerprint = cart => JSON.stringify((cart.items || []).map(i => [i.key,i.quantity]).sort());
        if (!after || fingerprint(after) !== fingerprint(freshCart)) { uncertain = true; throw new Error(t.uncertain); }
        sent = false;
        throw new Error(typeof result.description === 'string' ? result.description : t.error);
      }
      rows.forEach((r,i) => track('recommendation_added', {...r, placement: panel.dataset.placement, position:i+1}));
      try {
        const addedCollection = rows.length ? rows[rows.length - 1].collectionUrl : main()?.dataset.collectionUrl;
        if (addedCollection) {
          sessionStorage.setItem('hs_last_added_collection', addedCollection);
          sessionStorage.setItem('hs_active_collection', addedCollection);
        }
      } catch (_) { }
      if (panel) message(panel,t.added,'success');
      sent = false;
      if (drawer && result.sections?.['cart-drawer'] && result.sections?.['cart-icon-bubble']) {
        try {
          drawer.setActiveElement(purchaseTrigger);
          drawer.renderContents(result);
          freeze(false);
          if (panel) getCart().then(cart => { cartState = cart; return loadPanel(panel); }).catch(() => {});
          return;
        } catch (_) { }
      }
      window.location.assign(destination === 'checkout' ? root + 'checkout' : cfg.cartUrl);
    } catch (error) {
      if (sent) uncertain = true;
      message(panel, uncertain ? t.uncertain : error.message || t.error);
      if (uncertain) {
        const target = panel?.querySelector('[data-hs-status]') || main()?.querySelector('.product-form__error-message');
        if (target) { const link = document.createElement('a'); link.href = cfg.cartUrl; link.textContent = ' ' + t.check_cart; target.appendChild(link); }
      }
      freeze(false);
      if (uncertain) document.querySelectorAll('.hs-purchase button, .hs-purchase-sticky button, hs-pilot-panel button').forEach(el => { el.disabled = true; });
    }
  };
  if (!customElements.get('hs-pilot-panel')) customElements.define('hs-pilot-panel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true; this.loadToken = 0; this.rows = [];
      this.addEventListener('change', event => {
        const element = event.target;
        const variantIndex = element.dataset.hsVariant;
        const includeIndex = element.dataset.hsInclude;
        if (variantIndex !== undefined) {
          const row = this.rows[variantIndex];
          row.variantId = element.value;
          if (this.dataset.placement === 'product') row.checked = Boolean(element.value);
          draw(this);
          this.querySelector('[data-hs-variant="' + variantIndex + '"]')?.focus();
        }
        if (includeIndex !== undefined) { this.rows[includeIndex].checked = element.checked; syncMain(); }
      });
      this.addEventListener('click', event => {
        const element = event.target.closest('button,a');
        if (!element) return;
        if ('hsAddCombination' in element.dataset) perform(this,'cart');
        if ('hsCartAdd' in element.dataset) perform(this,'cart',this.rows[element.dataset.hsCartAdd]);
        if ('hsProductLink' in element.dataset) { const index = Number(element.dataset.hsProductLink); track('recommendation_clicked',{...this.rows[index],placement:this.dataset.placement,position:index+1}); }
      });
      if (cartState) loadPanel(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); this.loadToken++; }
  });
  document.addEventListener('submit', event => {
    if (event.target !== mainForm()) return;
    event.preventDefault(); event.stopImmediatePropagation();
    perform(main().querySelector('hs-pilot-panel'),'cart');
  }, true);
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-hs-checkout]')) return;
    event.preventDefault();
    perform(main()?.querySelector('hs-pilot-panel'),'checkout');
  });
  const init = async () => {
    if (main()) {
      const purchase = main();
      document.body.appendChild(purchase.querySelector('[data-hs-sticky]'));
      const observer = new MutationObserver(syncMain);
      observer.observe(mainForm().querySelector('[name="add"]'),{attributes:true,attributeFilter:['disabled'],childList:true,subtree:true});
      mainForm().querySelector('[name="id"]').addEventListener('change',syncMain);
      document.querySelectorAll('[name="quantity"][form="' + purchase.dataset.formId + '"]').forEach(input => input.addEventListener('change',syncMain));
      syncMain();
    }
    try { const [cart] = await Promise.all([getCart(), loadCatalog()]); cartState = cart; document.querySelectorAll('hs-pilot-panel').forEach(loadPanel); } catch (_) { }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
      const run = ++revision;
      try { const cart = await getCart(); if (run !== revision) return; cartState = cart; document.querySelectorAll('hs-pilot-panel').forEach(loadPanel); } catch (_) { }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-pilot-review"]) return;
  try {
    
(() => {
  const node=document.getElementById('HsMobileReviewData');if(!node)return;
  const data=JSON.parse(node.textContent);
  const escape=value=>String(value).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const fonts=[...document.querySelectorAll('style')].map(s=>s.textContent).filter(s=>s.includes('@font-face')).join('');
  document.querySelectorAll('[data-hs-mobile-review]').forEach(frame=>{
    const product=data.products.find(p=>p.id===data.sourceIds[Number(frame.dataset.hsMobileReview)]);
    const variant=product.variants.find(v=>v.available&&v.price>0);
    const cfg={enabled:true,productId:product.id,productHandle:product.handle,currency:'TRY',locale:'tr',root:'/',cartUrl:'/cart',catalogUrl:'/collections/all',families:data.families,mainVariants:product.variants,text:data.strings};
    const fixtureScript='window.reviewFixture='+JSON.stringify({products:data.products,catalog:data.catalog}).replace(/<\//g,'<\\/')+';';
    const simulator="(() => {\n      const products=new Map(window.reviewFixture.products.map(p=>[p.handle,p]));\n      let items=[];\n      window.fetch=async(url,options={})=>{\n        if(String(url).includes('section_id=hs-combination-catalog'))return {ok:true,text:async()=>'<script id=\"HsCombinationCatalog\">'+JSON.stringify({products:window.reviewFixture.catalog,next:null})+'</scr'+'ipt>'};\n        if(String(url).endsWith('/cart.js'))return {ok:true,json:async()=>({items,item_count:items.length,note:''})};\n        if(String(url).includes('/products/')){const handle=String(url).split('/products/')[1].replace('.js','');return {ok:products.has(handle),json:async()=>structuredClone(products.get(handle))};}\n        if(String(url).endsWith('/cart/add.js')){const submitted=JSON.parse(options.body).items;items.push(...submitted.map(item=>({...item,product_id:[...products.values()].find(p=>p.variants.some(v=>v.id===item.id)).id})));return {ok:true,json:async()=>({items:submitted})};}\n        throw new Error('Unexpected simulated endpoint');\n      };\n      document.querySelector('product-form').handleErrorMessage=value=>{document.querySelector('[data-review-error]').textContent=value||'';};\n      document.querySelector('[data-review-size]').addEventListener('change',event=>{const input=document.querySelector('[name=\"id\"]');input.value=event.target.value;input.dispatchEvent(new Event('change',{bubbles:true}));});\n    })();";
    const content='<main><h1>'+escape(product.title)+'</h1><label for="main-size">'+escape(data.strings.available_options)+'</label><select data-review-size id="main-size">'+product.variants.map(v=>'<option value="'+v.id+'"'+(v.id===variant.id?' selected':'')+(!v.available?' disabled':'')+'>'+escape(v.title)+'</option>').join('')+'</select><div class="hs-purchase" data-hs-purchase data-form-id="ReviewForm" data-collection-url="/collections/all"><product-form><p data-review-error class="product-form__error-message"></p><form id="ReviewForm"><input name="id" value="'+variant.id+'" type="hidden"><input name="quantity" value="1" type="hidden"><div class="hs-purchase-actions"><button class="hs-purchase-add" name="add" type="submit"><span>'+escape(data.strings.main_only)+'</span></button><button class="hs-purchase-now" data-hs-checkout type="button">'+escape(data.strings.buy_now)+'</button></div></form></product-form>'+data.panel+'<div data-hs-sticky class="hs-purchase-sticky"><span data-hs-sticky-price></span><button data-hs-sticky-add type="submit" form="ReviewForm"></button></div></div><output data-review-result aria-live="polite"></output></main>';
    const script=text=>'<script>'+text+'</scr'+'ipt>';
    frame.srcdoc='<!doctype html><html lang="tr"><head><meta name="viewport" content="width=device-width,initial-scale=1"><style>'+fonts+'html{font-size:62.5%;}*{box-sizing:border-box;}body{margin:0;font:15px Montserrat,sans-serif;color:#252b20;}main{padding:16px;}h1{font-size:20px;line-height:1.3;}select{width:100%;min-height:44px;font:16px Montserrat,sans-serif;}output{display:block;overflow-wrap:anywhere;font-size:12px;margin:18px 0;}'+data.css+'</style></head><body>'+content+'<script type="application/json" id="HsPilotConfig">'+JSON.stringify(cfg).replace(/<\//g,'<\\/')+'</scr'+'ipt><script type="application/json" id="HsCombinationProfiles">'+JSON.stringify({profiles:data.profiles}).replace(/<\//g,'<\\/')+'</scr'+'ipt>'+script(fixtureScript+simulator+data.runtime)+'</body></html>';
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-ux-product-rail"] && !Shopify.designMode) return;
  try {
    
(() => {
  const productPath = (link) => {
    if (!link) return '';
    try {
      return decodeURIComponent(new URL(link.href, document.baseURI).pathname).replace(/\/$/, '');
    } catch (_) { return ''; }
  };
  const syncGridExclusions = () => {
    const grid = document.getElementById('product-grid');
    if (!grid) return;
    const visible = new Set(Array.from(grid.children).slice(0, 4)
      .map(item => productPath(item.querySelector('a[href*="/products/"]'))).filter(Boolean));
    document.querySelectorAll('[data-hs-cr-version] hs-product-rail').forEach(rail => {
      const track = rail.querySelector('.hs-ux-rail__track');
      if (!track) return;
      let count = 0;
      Array.from(track.children).forEach(card => {
        card.hidden = visible.has(productPath(card.querySelector('a[href*="/products/"]')));
        if (!card.hidden) count++;
      });
      rail.parentElement.dataset.hsCrRendered = String(count);
      const guide = rail.querySelector('.hs-cr__guide');
      if (guide?.firstChild?.nodeType === Node.TEXT_NODE) guide.firstChild.nodeValue = `${count} ürün`;
    });
  };
  document.addEventListener('hardstone:commerce', event => {
    if (event.detail?.event === 'filter_applied') syncGridExclusions();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncGridExclusions, { once: true });
  else syncGridExclusions();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-ux-review"]) return;
  try {
    
(async()=>{const node=document.getElementById('UxVisualData');if(!node)return;const bytes=Uint8Array.from(atob(JSON.parse(node.textContent)),c=>c.charCodeAt(0));const data=JSON.parse(await new Response(new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'))).text());const page=document.getElementById('UxReviewPage'),width=document.getElementById('UxReviewWidth');const requested=new URLSearchParams(location.search).get('ux_page');if(data.pages['draft-'+requested])page.value=requested;
const guard="document.addEventListener('submit',e=>{e.preventDefault();e.stopImmediatePropagation()},true);document.addEventListener('click',e=>{const a=e.target.closest('a');if(a&&!a.getAttribute('href')?.startsWith('#')){e.preventDefault()}if(e.target.closest('[data-hs-filter-apply]'))e.target.closest('.mobile-facets__wrapper')?.querySelector('summary')?.click();},true);window.fetch=()=>Promise.reject(new Error('Visual comparison: transactions disabled'));";
const show=()=>{for(const type of ['live','draft']){const frame=document.getElementById(type==='live'?'UxLive':'UxDraft'),p=data.pages[type+'-'+page.value];frame.srcdoc='<!doctype html><html lang="tr" class="js"><head><meta name="viewport" content="width=device-width,initial-scale=1"><base href="https://hardstoneoutdoor.com/">'+(Array.isArray(p.head)?p.head.map(i=>data.fragments[i]).join(''):p.head)+'</head><body class="'+p.bodyClass+'">'+(Array.isArray(p.body)?p.body.map(i=>data.fragments[i]).join(''):p.body)+'<script>'+guard+data.scripts[type]+'</scr'+'ipt></body></html>';}};
page.addEventListener('change',show);width.addEventListener('change',()=>{for(const id of ['UxLive','UxDraft'])document.getElementById(id).width=width.value;});show();})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs2-discovery"] && !Shopify.designMode) return;
  try {
    
function createHs2Intelligence(config) {
  const breadthLimits = {strong:80, discovery:78, initial:4, extra:8};
  const profiles = new Map(config.profiles.map(p => [Number(p.id), p]));
  for (const override of config.profileOverrides || []) {
    if (!override.id || !override.role || !override.family) continue;
    const previous = profiles.get(Number(override.id)) || {};
    profiles.set(Number(override.id), {...previous, ...override, confidence: 'merchant_review'});
  }
  const profile = id => profiles.get(Number(id));
  const outfitRole = p => ({base:'first_layer',mid:'mid_layer',cap:'accessory',beanie:'accessory',belt:'accessory',bag:'accessory',outfit:'full_system'}[p?.role]
    || (p?.role === 'outer' ? (p.thermal === 'warm' ? 'outer_heavy' : ['light','mild','flex'].includes(p.thermal) ? 'outer_light' : null) : p?.role));
  const outfitPriorities = source => {
    const plans = {
      bottom:['first_layer','mid_layer','vest','outer_light','outer_heavy','accessory'],
      first_layer:['bottom','mid_layer','vest','outer_light','outer_heavy','accessory'],
      mid_layer:['bottom','first_layer','vest','outer_light','outer_heavy','accessory'],
      outer_light:['bottom','first_layer','mid_layer','vest','outer_heavy','accessory'],
      outer_heavy:['bottom','first_layer','mid_layer','vest','outer_light','accessory'],
      vest:['bottom','first_layer','mid_layer','outer_light','outer_heavy','accessory']
    };
    const season = config.context.season;
    const order = [...(plans[outfitRole(source)] || [])];
    if (season === 'winter' && order.includes('outer_heavy')) {
      order.splice(order.indexOf('outer_heavy'),1);
      order.splice(Math.min(3,order.length),0,'outer_heavy');
    }
    // Season is a ranking/compatibility signal, not a role-level hard wall.
    // pair() still rejects warm targets in summer, while thermalFit handles
    // spring/summer preference without hiding valid softshell layers.
    return order;
  };
  const normalizeSize = value => String(value || '').trim().toUpperCase().replace(/^XXXL$/, '3XL').replace(/^2XL$/, 'XXL');
  const stockHealth = entry => {
    if (config.setSystem && entry.system && entry.health) return entry.health;
    const variants = entry.variants || [];
    const purchasable = variants.filter(v => v.available && v.tracked && v.q > 0);
    if (!purchasable.length || entry.variantCount !== variants.length) return {score:0, coverage:0, suppressed:true, reason:'unavailable'};
    if (outfitRole(entry) === 'accessory') {
      return {score:70 + 30 * Math.min(3, Math.max(...purchasable.map(v => v.q))) / 3, coverage:null, suppressed:false, reason:'form_or_standard'};
    }
    const targets = [...new Set((entry.targetSizes || []).map(normalizeSize))];
    if (!targets.length || entry.sizeIndex < 0) return {score:0, coverage:0, suppressed:true, reason:'unverified_size_set'};
    // Other options (colour, fit) no longer make a product invisible: a size counts as available when any
    // colour has it, because the customer picks the colour on the product page itself.
    const sizes = new Map();
    for (const v of variants) {
      const size = normalizeSize(v.options[entry.sizeIndex]);
      const depth = v.available && v.tracked ? Math.max(0, Math.min(3, v.q)) : 0;
      sizes.set(size, Math.max(depth, sizes.get(size) || 0));
    }
    const depths = targets.map(size => sizes.get(size) || 0);
    const coverage = depths.filter(q => q > 0).length / depths.length;
    const depth = depths.reduce((sum,q) => sum + q, 0) / (3 * depths.length);
    const balance = 1 - (Math.max(...depths) - Math.min(...depths)) / 3;
    const score = Math.round((60 * coverage + 30 * depth + 10 * balance) * 10) / 10;
    return {score, coverage, depth, balance, suppressed:coverage < .5 || score < 40, reason:coverage < .5 ? 'size_coverage' : score < 40 ? 'stock_depth' : 'healthy'};
  };
  const zeroDemandSuppressed = entry => {
    const snapshot=entry?.demand;
    if(!snapshot||snapshot.method!=='hs_paid_net_90_v1'||snapshot.state!=='valid_zero')return false;
    const snapshotAge=config.now-Date.parse(snapshot.computed_at)/1000;
    const productAge=Math.max(0,(config.now-(Number(entry.createdAt)||0))/86400);
    return Number.isFinite(snapshotAge)&&snapshotAge>=0&&snapshotAge<=72*3600&&productAge>30;
  };
  const eligible = entry => entry.reviewed && entry.online && entry.available && entry.price > 0 && !entry.proxy && !entry.handle.endsWith('-meta')
    && entry.lifecycle !== 'DISCONTINUE' && entry.recStatus !== 'EXCLUDE' && !zeroDemandSuppressed(entry)
    && !['outfit','bib','full_system','cold_system','set'].includes(entry.role) && !entry.complete
    && !((entry.covers || []).includes('bottom') && (entry.covers || []).some(role => ['outer','outer_heavy'].includes(role))) && entry.variantCount === entry.variants?.length
    && entry.variants.some(v => v.available && v.tracked && v.q > 0);
  const stockBand = health => health.suppressed || health.score < 55 ? 0 : health.score < 70 ? 1 : health.score < 85 ? 2 : 3;
  const stockBandName = health => ['UNHEALTHY','WEAK','AMBER','GREEN'][stockBand(health)];
  const demand = entry => {
    const snapshot = entry.demand;
    const neutral = state => ({state,score:50,confidence:0});
    if (!snapshot || snapshot.method !== 'hs_paid_net_90_v1') return neutral('missing');
    const age = config.now - Date.parse(snapshot.computed_at) / 1000;
    if (!Number.isFinite(age) || age < -300) return neutral('missing');
    if (age > 72 * 3600) return neutral('stale');
    if (!['observed','valid_zero'].includes(snapshot.state) || !Number.isFinite(snapshot.score)
      || snapshot.score < 50 || snapshot.score > 100 || !Number.isFinite(snapshot.confidence)
      || snapshot.confidence < 0 || snapshot.confidence > 1) return neutral('missing');
    return {state:snapshot.state,score:snapshot.score,confidence:snapshot.confidence};
  };
  const compatibilityClass = entry => entry.score >= 99 ? 3 : entry.score >= 95 ? 2 : 1;
  const commercial = entry => {
    const age = Math.max(0, (config.now - entry.createdAt) / 86400);
    const freshness = entry.createdAt > 0 ? Math.max(0, 1 - age / 30) * 3 : 0;
    return Math.max(0,Math.min(100,Number(entry.recPriority) || 0)) / 10
      + ({HERO:4,CORE:2,SEASONAL:1}[entry.lifecycle] || 0) + (entry.recStatus === 'BOOST' ? 3 : 0) + freshness;
  };
  const demandLift = entry => {
    const state = entry.demandState || demand(entry);
    const confidence = Math.max(0,Math.min(1,Number(state?.confidence) || 0));
    const age = Math.max(0,(config.now - (Number(entry.createdAt) || 0)) / 86400);
    if (state?.state === 'observed') return Math.min(4,Math.max(0,(Number(state.score) - 50) * .08)) * confidence;
    if (state?.state === 'valid_zero' && age > 30) return -2.5 * confidence;
    return 0;
  };
  const discoveryRank = entry => Number(entry.score || 0) + demandLift(entry)
    + (entry.health ? Math.max(-1.5,Math.min(1.5,(Number(entry.health.score) - 70) * .02)) : 0);

  const isHead = p => ['cap', 'beanie'].includes(p.role);
  const isGear = p => ['cap', 'beanie', 'belt', 'bag'].includes(p.role);
  const isPlain = p => p.family === 'solid';
  const isExactPattern = (a,b) => Boolean(a?.exactPattern && b?.exactPattern && a.exactPattern === b.exactPattern);
  const covers = p => config.outfitV1 ? (p ? outfitRole(p) === 'full_system' ? ['bottom','outer_heavy'] : p.covers?.length > 1 ? p.covers : [outfitRole(p)] : []) : p?.covers || (p ? [isHead(p) ? 'head' : p.role === 'bib' ? 'bottom' : p.role] : []);
  const configuredGroups = (config.families || []).map(f => ({name: f.name, bundle: f.products.find(p => p.role === 'bundle')?.id, ids: f.products.map(p => Number(p.id))}));
  const groups = [...configuredGroups];
  for (const p of profiles.values()) {
    if (p.role === 'outfit' && p.components?.length && !groups.some(g => g.bundle === p.id)) groups.push({name: '', bundle: p.id, ids: [p.id, ...p.components]});
  }
  const sharedGroup = (a, b) => groups.find(g => g.ids.includes(a.id) && g.ids.includes(b.id));
  const idsInCart = cart => {
    const ids = new Set();
    const visit = item => {
      const id = Number(item.product_id);
      if (id) ids.add(id);
      for (const component of item.item_components || []) visit(component);
      for (const componentId of profile(id)?.components || []) ids.add(Number(componentId));
    };
    for (const item of cart?.items || []) visit(item);
    return ids;
  };
  const occupiedSlots = (cart, sourceId) => {
    const result = new Set();
    for (const id of idsInCart(cart)) for (const slot of covers(profile(id))) result.add(slot);
    for (const slot of covers(profile(sourceId))) result.add(slot);
    return result;
  };
  const priorities = source => {
    if (source.role === 'base') return source.thermal === 'hot' ? ['bottom', 'vest', 'cap'] : ['bottom', 'vest', 'mid', 'cap', 'beanie'];
    if (source.role === 'mid') return ['bottom', 'vest', 'base', 'beanie', 'cap'];
    if (source.role === 'outer') return ['bottom', 'mid', 'base', 'beanie', 'cap'];
    if (source.role === 'vest') return source.thermal === 'warm' ? ['bottom', 'mid', 'base', 'beanie', 'cap'] : ['bottom', 'base', 'mid', 'cap', 'beanie'];
    if (source.role === 'bottom') return source.style === 'casual' ? ['base', 'mid', 'cap', 'beanie'] : ['base', 'vest', 'mid', 'cap', 'beanie'];
    if (source.role === 'bib') return ['mid', 'base', 'outer', 'beanie', 'cap'];
    if (source.role === 'outfit') {
      if (covers(source).includes('vest')) return ['bottom', 'beanie', 'cap', 'mid'];
      if (covers(source).includes('mid')) return ['base', 'vest', 'beanie', 'cap'];
      return ['mid', 'base', 'beanie', 'cap'];
    }
    if (isHead(source)) return source.thermal === 'warm' ? ['mid', 'bottom', 'base', 'vest'] : ['base', 'bottom', 'vest', 'mid'];
    return ['bottom', 'base', 'vest', 'mid'];
  };
  const pair = (source, target, intent = 'strong', systemIntent = null) => {
    const systemScope = config.setSystem && source?.system && ['build','world','compare'].includes(systemIntent);
    if (systemScope && systemIntent === 'compare') {
      if (!target?.system || target.id === source.id || target.cohort === 'unknown' || target.cohort === 'bib') return null;
      const overlap = (source.covers || []).filter(r => target.covers?.includes(r)).length;
      if (!overlap) return null;
      // Another ready-made set is a real alternative whenever it dresses the same body zone.
      // Same cohort ranks first, then same pattern family, then the rest of the set catalogue.
      const sameFamily = target.family !== 'unknown' && target.family === source.family;
      return {score:target.cohort === source.cohort ? 97 : sameFamily ? 93 : 88 + Math.min(3,overlap), reason:'reason_family', match:'system', confidence:'strong', priority:0, source};
    }
    if (systemScope && target?.system) return null;
    const covered = new Set((source?.covers || []).map(r => r.startsWith('outer_') ? 'outer' : r));
    const targetExposure = outfitRole(target)?.startsWith('outer_') ? 'outer' : outfitRole(target);
    if (systemScope && (systemIntent === 'build' && covered.has(targetExposure) || targetExposure === 'accessory' && covered.has('accessory'))) return null;
    if (!source || !target || source.id === target.id || target.role === 'outfit' || target.role === 'bib') return null;
    if (source.variantFamily && target.variantFamily && source.variantFamily === target.variantFamily) return null;
    if (target.confidence === 'pattern_review' || target.family === 'unknown') return null;
    if (config.outfitV1) {
      const context = config.context;
      if (outfitRole(source) === 'full_system' && !systemScope || ['full_system','cold_system','set'].includes(outfitRole(target)) || !target.reviewed || outfitRole(target) === outfitRole(source) || !target.activities?.length || !isExactPattern(source, target) && (!target.terrains?.includes(context.terrain) || !target.seasons?.includes(context.season))) return null;
      const role = outfitRole(target);
      if (context.season === 'summer' && target.thermal === 'warm') return null;
      if (role === 'outer_heavy' && target.thermal !== 'warm') return null;
      if (role === 'outer_light' && !['light','mild','flex'].includes(target.thermal)) return null;
      const activityIndex = target.activities.indexOf(context.activity);
      const activity = context.activity === 'outdoor'
        ? (target.activities.includes('outdoor') ? 35 : 0)
        : activityIndex === 0 ? 35 : activityIndex > 0 ? 31 : target.activities.includes('outdoor') ? 24 : 0;
      if (!activity) return null;
      const visible = p => p.palette?.includes('orange') || p.pattern?.startsWith('neon_');
      const shared = (source.palette || []).filter(c => target.palette?.includes(c)).length;
      const forest = ['oak','woodland','branch'];
      const exact = isExactPattern(source,target);
      let pattern = 0, reason = 'reason_tones', match = 'compatible';
      if (exact) { pattern = 25; reason = 'reason_pattern'; match = 'exact'; }
      else if (visible(source) && visible(target)) { pattern = 22; match = 'visibility'; }
      else if (source.family === target.family && source.family !== 'solid' && (shared || visible(source) !== visible(target) || systemScope && source.family !== 'unknown')) { pattern = 21 + Math.min(2,shared); reason = 'reason_family'; }
      else if (forest.includes(source.family) && forest.includes(target.family) && visible(source) !== visible(target)) { pattern = 18 + Math.min(2,shared); reason = 'reason_family'; }
      else if (forest.includes(source.family) && forest.includes(target.family) && shared) pattern = 19 + Math.min(2,shared);
      else if (source.family === 'solid' || target.family === 'solid') {
        const earthy = target.palette?.some(c => ['olive','brown','tan','black','charcoal','grey'].includes(c));
        if (visible(source) === visible(target)) {
          if (source.family === 'solid' && target.family === 'solid') { if (shared || earthy) { pattern = 21 + Math.min(2,shared); reason = 'reason_plain'; } }
          else if (shared) { pattern = 17 + Math.min(2,shared); reason = 'reason_plain'; }
          else if (earthy) { pattern = 15; reason = 'reason_plain'; }
        }
      }
      let confidence = 'strong';
      if (!pattern && intent === 'discovery' && source.terrains?.includes(context.terrain)
        && source.seasons?.includes(context.season)) {
        if (!visible(source) && !visible(target) && shared >= 2) {
          pattern = 14 + Math.min(2, shared - 2);
          confidence = 'compatible';
        } else {
          // Layer-completion fallback: context fit can rescue a missing physical
          // layer even when pattern/palette overlap is weak. This feeds the
          // vertical layering system; later world/alternative merch remains stricter.
          pattern = 10 + Math.min(2, shared);
          confidence = 'compatible';
          reason = 'reason_tones';
          match = 'context';
        }
      }
      if (!pattern) return null;
      const priority = systemScope ? ['first_layer','mid_layer','vest','bottom','outer_light','outer_heavy','accessory'].indexOf(outfitRole(target)) : outfitPriorities(source).indexOf(outfitRole(target));
      if (priority < 0) return null;
      const thermalFit=(()=>{
        const season=context.season,thermal=target.thermal,role=outfitRole(target);
        if(season==='winter')return thermal==='warm'?4:thermal==='mild'?2:thermal==='flex'?1:0;
        if(season==='autumn')return thermal==='warm'?3:thermal==='mild'?3:thermal==='flex'?2:thermal==='light'?1:0;
        if(season==='spring')return thermal==='mild'?3:thermal==='flex'?3:thermal==='light'?2:thermal==='warm'&&role==='mid_layer'?1:0;
        if(season==='summer')return ['hot','light'].includes(thermal)?3:thermal==='flex'?2:0;
        return 0;
      })();
      const score = activity + 20 + pattern + 20 + thermalFit;
      if (score < (confidence === 'strong' ? breadthLimits.strong : breadthLimits.discovery)) return null;
      return {score,reason,match,confidence,group:null,priority,source};
    }
    const group = sharedGroup(source, target);
    if (!group) {
      if (source.neon === 0 && target.neon === 2) return null;
      if (source.neon === 2 && target.neon === 0 && !isPlain(target)) return null;
    }
    if (source.thermal === 'hot' && target.thermal === 'warm') return null;
    if (source.role === 'bottom' && source.thermal === 'light' && target.thermal === 'warm') return null;
    if (source.thermal === 'warm' && target.role === 'bottom' && ['hot', 'light'].includes(target.thermal)) return null;
    if (source.thermal === 'warm' && target.role === 'base' && target.thermal === 'hot') return null;
    if (source.style === 'field' && target.style === 'casual' && target.role === 'bottom') return null;
    if (source.style === 'casual' && target.style === 'field' && !['base', 'cap', 'beanie'].includes(target.role)) return null;
    const shared = source.palette.filter(c => target.palette.includes(c));
    const samePattern = isExactPattern(source,target);
    const sameFamily = source.family !== 'unknown' && source.family === target.family;
    const forest = new Set(['oak', 'woodland', 'branch']);
    const forestMatch = forest.has(source.family) && forest.has(target.family) && shared.length >= 2;
    const plainMatch = isPlain(source) || isPlain(target);
    if (!group && !samePattern && !sameFamily && !forestMatch && !plainMatch) return null;
    if (!group && !shared.length && !plainMatch) return null;
    if (!group && !plainMatch && Math.abs(source.brightness - target.brightness) > 1) return null;
    if (source.family === 'unknown' && !isPlain(target)) return null;
    if (plainMatch && !shared.length && !target.palette.some(c => ['olive', 'black', 'charcoal', 'brown', 'tan'].includes(c))) return null;
    let score = group ? (isGear(source) ? 32 : 105) : 0;
    let reason = group ? 'reason_set' : 'reason_plain';
    if (samePattern) { score += 64; if (!group) reason = 'reason_pattern'; }
    else if (sameFamily && !isPlain(source)) { score += 42; if (!group) reason = 'reason_family'; }
    else if (forestMatch) { score += 28; if (!group) reason = 'reason_tones'; }
    else if (plainMatch) score += isPlain(source) && isPlain(target) ? 48 : 30;
    score += Math.min(shared.length, 3) * 9;
    if (source.palette[0] === target.palette[0]) score += 12;
    if (!shared.length && plainMatch) score += 8;
    score -= Math.abs(source.brightness - target.brightness) * 5;
    if (source.thermal === target.thermal || target.thermal === 'flex') score += 7;
    if (source.line && source.line === target.line) score += 10;
    if (source.neon === 2 && target.neon === 2) score += 8;
    const priority = priorities(source).indexOf(target.role);
    if (priority < 0) return null;
    score += Math.max(6, 36 - priority * 6);
    if (score < 62) return null;
    return {score, reason, group, priority, source};
  };
  const chooseAnchors = (cart, sourceId, placement) => {
    if (placement === 'product') {
      const current = profile(sourceId);
      // PDP anchor health/status must not collapse Discovery. Eligibility and
      // stock suppression apply to recommendation targets, not to the product
      // the customer is already viewing.
      if (config.outfitV1 && !current) return [];
      return current && !current.complete ? [current] : [];
    }
    if ((cart?.items || []).some(item => profile(item.product_id)?.complete)) return [];
    let anchors = [...new Map((cart?.items || []).map(i => profile(i.product_id)).filter(Boolean).filter(p => !p.complete).map(p => [p.id, p])).values()];
    const clothing = anchors.filter(p => !isGear(p));
    if (clothing.length) anchors = clothing;
    const patterned = anchors.filter(p => !isPlain(p) && p.family !== 'unknown');
    if (!patterned.length) return anchors.slice(0, 1);
    const strength = a => patterned.reduce((sum, b) => sum + (a.id === b.id || sharedGroup(a,b) || (a.family === b.family && a.neon === b.neon) ? covers(b).length : 0), 0);
    const dominant = patterned.map((p, index) => ({p, index, score: strength(p)})).sort((a,b) => b.score - a.score || a.index - b.index)[0].p;
    return patterned.filter(p => p.id === dominant.id || sharedGroup(dominant,p) || (p.family === dominant.family && p.neon === dominant.neon));
  };
  const rank = (placement, cart, sourceId, catalog, intent = 'strong') => {
    const anchors = chooseAnchors(cart, sourceId, placement);
    if (!anchors.length) return [];
    const occupied = idsInCart(cart);
    if (placement === 'product') occupied.add(Number(sourceId));
    const slots = occupiedSlots(cart, placement === 'product' ? sourceId : null);
    if (!config.outfitV1 && ['base', 'vest', 'bottom', 'head'].every(slot => slots.has(slot))) return [];
    const entries = new Map(catalog.map(p => [Number(p.id), p]));
    const result = [];
    for (const entry of catalog) {
      const target = profile(entry.id);
      if (config.outfitV1 && (!eligible(entry) || entry.recStatus === 'SUPPRESS')) continue;
      if (!target || !entry.available || !(entry.price > 0) || occupied.has(Number(entry.id))) continue;
      if (entry.handle.endsWith('-meta') || entry.proxy || target.role === 'outfit' || target.role === 'bib') continue;
      if (covers(target).some(slot => slots.has(slot))) continue;
      if (!config.outfitV1 && ((target.role === 'outer' && slots.has('vest')) || (target.role === 'vest' && slots.has('outer')))) continue;
      const options = anchors.map(a => pair(a, target, intent)).filter(Boolean).sort((a,b) => b.score - a.score || a.priority - b.priority);
      if (!options.length) continue;
      const match = options[0];
      const health = config.outfitV1 ? stockHealth(entry) : null;
      if (health?.suppressed) continue;
      const bundleEntry = match.group?.bundle ? entries.get(match.group.bundle) : null;
      const bundle = bundleEntry?.available && bundleEntry.price > 0 && !occupied.has(bundleEntry.id) ? {id:bundleEntry.id, url:bundleEntry.url, title:bundleEntry.title} : null;
      const family = match.group ? (match.group.name || bundleEntry?.title || '') : match.source.family;
      result.push({...entry, confidence:match.confidence, health, demandState:config.outfitV1 ? demand(entry) : null, match:match.match, commercial:config.outfitV1 ? commercial(entry) : 0, role:config.outfitV1 ? outfitRole(target) : target.role, family, familyKey:match.source.family, reason:match.reason, score:match.score, priority:match.priority, sourceId:match.source.id, bundle,
        selectionGroup: config.outfitV1 ? outfitRole(target) : isHead(target) ? 'head' : ['base','mid'].includes(target.role) ? 'inner' : target.role});
    }
    if (config.outfitV1) {
      const diversity = entry => ((Number(sourceId) % 997) * (entry.id % 991)) % 997;
      const ordered = result.sort((a,b) => compatibilityClass(b) - compatibilityClass(a) || discoveryRank(b) - discoveryRank(a) || stockBand(b.health) - stockBand(a.health) || b.score - a.score || b.demandState.score - a.demandState.score || b.commercial - a.commercial || diversity(a) - diversity(b));
      if (intent === 'discovery') return ordered;
      const roles = new Set();
      return ordered.filter(entry => {
        if (roles.has(entry.selectionGroup)) return false;
        roles.add(entry.selectionGroup); return true;
      }).sort((a,b) => a.priority - b.priority);
    }
    return result.sort((a,b) => a.priority - b.priority || b.score - a.score || a.id - b.id);
  };
  const rankSystem = (sourceId, catalog, intent) => {
    const source = profile(sourceId);
    if (!config.setSystem || !source?.system || !source.covers?.length) return [];
    return catalog.filter(p => p.id !== sourceId && p.online && p.available && p.price > 0 && !p.proxy && !p.handle.endsWith('-meta') && !['EXCLUDE','SUPPRESS'].includes(p.recStatus) && p.lifecycle !== 'DISCONTINUE' && (p.system ? intent === 'compare' && !zeroDemandSuppressed(p) : eligible(p))).map(p => {
      const match = pair(source,p,'discovery',intent), health = stockHealth(p);
      if (!match || health.suppressed) return null;
      return {...p,...match,health,demandState:demand(p),commercial:commercial(p),role:p.system?'full_system':outfitRole(p)};
    }).filter(Boolean).sort((a,b) => compatibilityClass(b)-compatibilityClass(a) || discoveryRank(b)-discoveryRank(a) || stockBand(b.health)-stockBand(a.health) || b.score-a.score || b.demandState.score-a.demandState.score || b.commercial-a.commercial || a.id-b.id);
  };
  const breadth = (sourceId, catalog) => {
    const all = rank('product', null, sourceId, catalog, 'discovery');
    const strong = all.filter(entry => entry.confidence === 'strong');
    const compatible = all.filter(entry => entry.confidence === 'compatible');
    const exposureFamily = entry => ['outer_light','outer_heavy'].includes(entry.selectionGroup) ? 'outer' : entry.selectionGroup;
    const roles = new Set();
    const initial = strong.filter(entry => {
      const family = exposureFamily(entry);
      if (roles.has(family)) return false;
      roles.add(family); return true;
    }).sort((a,b) => a.priority - b.priority).slice(0, breadthLimits.initial);
    const selected = new Set(initial.map(entry => Number(entry.id)));
    const extra = [];
    const budgets = {outer:2,mid_layer:2,first_layer:2,bottom:2,vest:2,accessory:2};
    const counts = {};
    for (const entry of initial) counts[exposureFamily(entry)] = (counts[exposureFamily(entry)] || 0) + 1;
    const remaining = strong.concat(compatible).filter(entry => !selected.has(Number(entry.id)));
    while (remaining.length && extra.length < breadthLimits.extra) {
      const index = remaining.findIndex(entry => (counts[exposureFamily(entry)] || 0) < 1);
      const entry = remaining.splice(index < 0 ? 0 : index,1)[0];
      const family = exposureFamily(entry);
      if ((counts[family] || 0) >= (budgets[family] || 2)) continue;
      selected.add(Number(entry.id)); counts[family] = (counts[family] || 0) + 1; extra.push(entry);
    }
    return {initial, extra, strong, compatible, excludedIds:new Set([Number(sourceId), ...all.map(entry => Number(entry.id))])};
  };
  return {rankSystem, rank, breadth, breadthLimits, pair, profile, idsInCart, occupiedSlots, chooseAnchors, stockHealth, eligible, stockBand, stockBandName, demand, outfitPriorities};
}
(() => {
  if (customElements.get('hs2-discovery')) return;
  const isExactPattern=(a,b)=>Boolean(a?.exactPattern&&b?.exactPattern&&a.exactPattern===b.exactPattern);
  const roleOf=p=>({base:'first_layer',mid:'mid_layer',cap:'accessory',beanie:'accessory',belt:'accessory',bag:'accessory'}[p?.role]||(p?.role==='outer'?p.thermal==='warm'?'outer_heavy':'outer_light':p?.role));
  const exposure=p=>roleOf(p)?.startsWith('outer_')?'outer':roleOf(p);
  const visible=p=>p.palette?.includes('orange')||p.pattern?.startsWith('neon_');
  const reduced=()=>matchMedia('(prefers-reduced-motion:reduce)').matches;
  const el=(tag,cls,text)=>{const n=document.createElement(tag);if(cls)n.className=cls;if(text!==undefined)n.textContent=text;return n;};
  const emptyMemory=()=>({v:4,visits:[],moments:[],layouts:[],pages:[]});
  const memoryKey='hs2-journey-v4';
  const pruneMemory=(raw,now=Date.now())=>{
    const fresh=r=>r&&Number.isFinite(r.at)&&now-r.at>=0&&now-r.at<1800000;
    const list=(key,max)=>(Array.isArray(raw?.[key])?raw[key]:[]).filter(fresh).slice(-max);
    return {v:4,visits:list('visits',10),moments:list('moments',24),layouts:list('layouts',8),pages:list('pages',6)};
  };
  const journey=anchor=>{
    let data=emptyMemory();try{data=pruneMemory(JSON.parse(sessionStorage.getItem(memoryKey)||'null'));}catch{}
    const input={visits:[...data.visits],moments:[...data.moments],layouts:[...data.layouts]};
    let key;try{key=history.state?.hs2Journey;if(!key){key=Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,7);history.replaceState({...history.state,hs2Journey:key},'');}}catch{key=String(Date.now());}
    const saved=data.pages.find(p=>p.key===key&&p.anchor===anchor.id),seen=new Set();
    const flush=()=>{try{data=pruneMemory(data);sessionStorage.setItem(memoryKey,JSON.stringify(data));}catch{}};
    if(!saved)data.visits.push({id:anchor.id,role:roleOf(anchor),family:anchor.family,terrain:anchor.terrains?.[0],at:Date.now()});
    const commit=plan=>{
      const packed={primary:plan.primary.map(p=>p.id),companions:(plan.companions||[]).map(p=>p.id),alternatives:[...plan.alternatives].map(([id,rows])=>[id,rows.map(p=>p.id)]),world:plan.world.map(p=>p.id),accessories:(plan.accessories||[]).map(p=>p.id),substitutes:plan.substitutes.map(p=>p.id),composition:plan.composition,moments:plan.moments,orchestration:plan.orchestration,...(plan.setAxes?{setAxes:plan.setAxes}: {})};
      const prior=data.pages.find(p=>p.key===key);if(prior){prior.plan={...prior.plan,...packed};prior.at=Date.now();}else{data.pages.push({key,anchor:anchor.id,at:Date.now(),plan:packed});data.layouts.push({role:roleOf(anchor),key:plan.composition,types:plan.moments.map(m=>m.type),at:Date.now()});}flush();
    };
    const impression=(p,kind)=>{
      if(!p||seen.has(kind+':'+p.id))return;seen.add(kind+':'+p.id);
      data.moments=data.moments.filter(m=>!(m.id===p.id&&m.kind===kind&&m.anchor===anchor.id));
      data.moments.push({id:p.id,role:roleOf(p),pattern:p.pattern,tone:p.palette?.[0],family:p.family,kind,anchor:anchor.id,at:Date.now()});flush();
    };
    const select=(id,active)=>{const page=data.pages.find(p=>p.key===key);if(page){page.plan.selected={...page.plan.selected,[id]:active};flush();}};const navigation=rails=>{const page=data.pages.find(p=>p.key===key);if(page){page.plan.rails=rails;flush();}};const depth=open=>{const page=data.pages.find(p=>p.key===key);if(page){page.plan.depthOpen=open;flush();}};return {input,saved:saved?.plan,commit,impression,select,navigation,depth,flush};
  };
  const band=p=>p.health.score>=85?3:p.health.score>=70?2:1;
  const quality=p=>p.score>=99?3:p.score>=95?2:1;
  const merchant=p=>p.commercial??((Number(p.recPriority)||0)/10+({HERO:4,CORE:2,SEASONAL:1}[p.lifecycle]||0)+(p.recStatus==='BOOST'?3:0));
  const closeQuality=(p,q)=>p.score>=q.score-3&&band(p)===band(q)&&(p.demandState?.score||50)>=(q.demandState?.score||50)-5&&merchant(p)>=merchant(q)-3;
  const fatigue=(p,memory,kind)=>{
    const visits=memory?.visits||[],moments=(memory?.moments||[]).filter(m=>m.kind!=='explore').slice(-16);
    let cost=visits.slice(-6).reduce((n,v,i)=>n+(v.id===p.id?5+i:0),0);
    cost+=moments.reduce((n,m,i)=>n+(m.id===p.id?(m.kind===kind?7:4)+i/8:0),0);
    const last=moments.slice(-3);cost+=last.reduce((n,m)=>n+(m.role===roleOf(p)?0.3:0)+(m.pattern===p.pattern?0.35:0)+(m.tone===p.palette?.[0]?0.2:0),0);
    return cost;
  };
  const uniqueVariantFamilies=(rows,limit=rows.length)=>{
    const out=[],seen=new Set();
    for(const p of rows){
      const key=p.variantFamily||null;
      if(key&&seen.has(key))continue;
      if(key)seen.add(key);
      out.push(p);
      if(out.length>=limit)break;
    }
    return out;
  };
  const distinct=(rows,chosen,limit,memory={},kind='primary')=>{
    const out=[],pool=[...rows];
    while(pool.length&&out.length<limit){
      const first=pool[0],refs=chosen.concat(out),finalists=pool.filter(p=>closeQuality(p,first));
      const gain=p=>refs.reduce((n,q)=>n+(q.pattern!==p.pattern?0.5:0)+(q.family!==p.family?0.3:0)+(roleOf(q)!==roleOf(p)?0.4:0)+(p.variantFamily&&q.variantFamily&&p.variantFamily!==q.variantFamily?0.7:0),0);
      const familyCost=p=>refs.reduce((n,q)=>n+(p.variantFamily&&q.variantFamily&&p.variantFamily===q.variantFamily?5:0),0);
      finalists.sort((a,b)=>(fatigue(a,memory,kind)+familyCost(a)-gain(a)-contextBias(a,memory))-(fatigue(b,memory,kind)+familyCost(b)-gain(b)-contextBias(b,memory))||pool.indexOf(a)-pool.indexOf(b));
      const selected=finalists[0]||first;out.push(selected);pool.splice(pool.indexOf(selected),1);
    }return out;
  };
  const recipes={
    bottom:['first_layer','mid_layer','outer_light','outer_heavy'],
    first_layer:['mid_layer','outer_light','outer_heavy'],
    mid_layer:['first_layer','outer_light','outer_heavy'],
    outer_light:['first_layer','mid_layer','outer_heavy'],
    outer_heavy:['first_layer','mid_layer','outer_light'],
    vest:['first_layer','mid_layer','outer_light','outer_heavy']
  };
  const compositionFor=(role,memory)=>{
    const choices={bottom:['ascent','ascent-split'],first_layer:['trail','trail-pair'],mid_layer:['shelter','shelter-offset'],outer_heavy:['inner-pair','inner-offset'],outer_light:['weather-pair','weather-offset'],vest:['field-pair','field-offset']}[role]||['ascent','ascent-split'];
    const last=(memory.layouts||[]).filter(m=>m.role===role).at(-1);return last?.key===choices[0]?choices[1]:choices[0];
  };
  const merchandise=(cfg,engine,memory={},saved)=>{
    const anchor=engine.profile(cfg.productId),empty={anchor,primary:[],companions:[],alternatives:new Map(),totals:new Map(),world:[],accessories:[],substitutes:[],composition:compositionFor(roleOf(anchor),memory)};
    if(!engine.chooseAnchors(null,cfg.productId,'product').length)return empty;
    const all=engine.rank('product',null,cfg.productId,cfg.profiles,'discovery'),strong=all.filter(p=>p.confidence==='strong');
    const recipe=recipes[roleOf(anchor)]||recipes.bottom;
    const restore=(rows,ids)=>{const positions=new Map((ids||[]).map((id,i)=>[id,i]));return [...rows].sort((a,b)=>(positions.get(a.id)??999)-(positions.get(b.id)??999));};
    const primary=[];
    for(const wantedRole of recipe){
      if(primary.length>=4)break;
      const roleRows=all.filter(p=>roleOf(p)!=='accessory'&&roleOf(p)===wantedRole);
      if(!roleRows.length)continue;
      const exactRows=roleRows.filter(p=>isExactPattern(p,anchor));
      const strongRows=roleRows.filter(p=>p.confidence==='strong');
      const pool=exactRows.length?exactRows:strongRows.length?strongRows:roleRows;
      const selected=(saved?restore(pool,saved.primary):distinct(pool,primary,1,memory))[0];
      if(selected)primary.push(selected);
    }
    const companionRoles=[];
    const anchorRole=roleOf(anchor);
    if(anchorRole!=='bottom')companionRoles.push('bottom');
    if(anchorRole!=='vest')companionRoles.push('vest');
    const companions=[];
    for(const wantedRole of companionRoles){
      const rows=all.filter(p=>roleOf(p)===wantedRole&&!primary.some(q=>q.id===p.id));
      const exactRows=rows.filter(p=>isExactPattern(p,anchor));
      const strongRows=rows.filter(p=>p.confidence==='strong');
      const pool=exactRows.length?exactRows:strongRows.length?strongRows:rows;
      const picked=[];
      for(let n=0;n<2;n++){
        const left=pool.filter(p=>!picked.some(q=>q.id===p.id));
        const selected=(saved?.companions?restore(left,saved.companions):distinct(left,[...primary,...companions,...picked],1,memory,'companion'))[0];
        if(!selected)break;
        picked.push(selected);
        if(saved?.companions&&!saved.companions.includes(selected.id)){picked.pop();break;}
      }
      companions.push(...picked);
    }
    const used=new Set([Number(cfg.productId),...primary.map(p=>Number(p.id)),...companions.map(p=>Number(p.id))]),alternatives=new Map(),totals=new Map();
    const forest=['oak','woodland','branch'];
    const contextual=cfg.profiles.filter(p=>!used.has(Number(p.id))&&engine.eligible(p)&&p.recStatus!=='SUPPRESS'&&!engine.stockHealth(p).suppressed&&!(anchor.variantFamily&&p.variantFamily===anchor.variantFamily)&&p.family!=='unknown'&&p.confidence!=='pattern_review'&&p.terrains?.includes(cfg.context.terrain)&&p.seasons?.includes(cfg.context.season)&&(p.activities?.includes(cfg.context.activity)||p.activities?.includes('outdoor')));
    const visibleCompatible=p=>true; // Neon/forest is a ranking signal, never a merchandising hard wall.
    const weatherCompatible=p=>!(cfg.context.season==='summer'&&p.thermal==='warm');
    const decorate=(p,score)=>({...p,score,health:engine.stockHealth(p),demandState:engine.demand(p)});
    const order=(a,b)=>quality(b)-quality(a)||b.score-a.score||engine.stockBand(b.health)-engine.stockBand(a.health)||b.health.score-a.health.score||b.demandState.score-a.demandState.score||merchant(b)-merchant(a)||a.id-b.id;
    const worldPool=contextual.filter(p=>roleOf(p)!==roleOf(anchor)&&visibleCompatible(p)&&weatherCompatible(p)).map(p=>{
      const shared=(p.palette||[]).filter(c=>anchor.palette?.includes(c)).length,exact=isExactPattern(p,anchor),family=p.family===anchor.family&&p.family!=='solid',activity=p.activities?.includes(cfg.context.activity)&&cfg.context.activity!=='outdoor',terrain=p.terrains?.includes(cfg.context.terrain),weather=p.thermal===anchor.thermal;
      const plainAnchor=anchor.family==='solid',plainLoud=plainAnchor&&visible(anchor)!==visible(p);
      const related=!plainLoud&&(exact||family||p.family==='solid'||forest.includes(p.family)&&forest.includes(anchor.family)||shared>=2||activity&&terrain&&weather&&shared||plainAnchor&&shared>=1);
      if(!related)return null;
      const connections=[...(exact||family?['pattern']:[]),...(shared>=2||p.family==='solid'?['palette']:[]),...(activity?['activity']:[]),...(terrain?['terrain']:[]),...(weather?['weather']:[])];
      const visibilityFit=visible(anchor)===visible(p)?3:(cfg.context.activity==='boar'?1:-2);
      const plainScore=plainAnchor?(p.family==='solid'?(shared?97:94):shared>=2?92:89):null;
      return {...decorate(p,(exact?104:plainScore??(family?97:shared>=2?93:p.family==='solid'?91:88))+visibilityFit),connections};
    }).filter(Boolean).sort(order);
    const occupied=new Set(primary.map(exposure));
    const preferred=worldPool.filter(p=>!occupied.has(exposure(p))&&roleOf(p)!=='accessory');
    let world=saved?restore(worldPool,saved.world).filter(p=>saved.world.includes(p.id)):distinct(preferred,[],1,memory,'same-world');
    if(!saved){
      while(world.length<2){const other=distinct(worldPool.filter(p=>!world.some(q=>q.id===p.id||exposure(q)===exposure(p))&&roleOf(p)!=='accessory'),world,1,memory,'same-world')[0];if(!other)break;world.push(other);}
      const repeated=(memory.visits||[]).slice(-3).filter(v=>v.family===anchor.family).length>=2;
      if(repeated&&world.length){
        const current=world[world.length-1],near=worldPool.filter(p=>!world.some(q=>q.id===p.id)&&!world.slice(0,-1).some(q=>exposure(q)===exposure(p))&&roleOf(p)!=='accessory'&&p.family!==anchor.family&&p.connections?.some(c=>['palette','activity','terrain'].includes(c))&&closeQuality(p,current));
        const surprise=distinct(near,world,1,memory,'same-world')[0];if(surprise)world[world.length-1]={...surprise,serendipity:true};
      }
    }
    // Field System is clothing-only. Headwear/bags have their own Field Gear
    // section below, so they should not consume world slots or repeat twice.
    world=uniqueVariantFamilies(world.filter(p=>roleOf(p)!=='accessory'),3);world.forEach(p=>used.add(Number(p.id)));
    for(const p of primary){alternatives.set(p.id,[]);totals.set(p.id,strong.filter(q=>roleOf(q)===roleOf(p)&&!world.some(w=>w.id===q.id)).length);}
    let budget=12;
    for(let round=0;round<5;round++)for(const p of primary){
      if(!budget)break;const chosen=alternatives.get(p.id),pool=strong.filter(q=>roleOf(q)===roleOf(p)&&!used.has(Number(q.id))&&!(q.variantFamily&&chosen.some(r=>r.variantFamily===q.variantFamily))),frozen=saved?.alternatives.find(([id])=>id===p.id)?.[1];
      const q=(saved?restore(pool,frozen):distinct(pool,[p,...chosen],1,memory,'explore'))[0];
      if(q){chosen.push(q);used.add(Number(q.id));budget--;}
    }
    let sameRole=contextual.filter(p=>!used.has(Number(p.id))&&roleOf(p)===roleOf(anchor)&&visibleCompatible(p)&&weatherCompatible(p)&&(p.family===anchor.family&&(anchor.family!=='solid'||visible(p)===visible(anchor))||p.family==='solid'&&(anchor.family!=='solid'||visible(p)===visible(anchor))||anchor.family==='solid'&&visible(p)===visible(anchor)&&(p.palette||[]).some(c=>anchor.palette?.includes(c))||forest.includes(p.family)&&forest.includes(anchor.family))).map(p=>{
      const visibilityFit=visible(anchor)===visible(p)?3:(cfg.context.activity==='boar'?1:-2);
      return decorate(p,(isExactPattern(p,anchor)?100:p.family===anchor.family?97:92)+visibilityFit);
    }).sort(order);
    if(!sameRole.length&&['outer_light','outer_heavy'].includes(roleOf(anchor))){
      // A plain coat falls back to other quiet coats only: same visibility, plain or sharing a tone.
      const quietFit=p=>anchor.family!=='solid'||visible(p)===visible(anchor)&&(p.family==='solid'||(p.palette||[]).some(c=>anchor.palette?.includes(c)));
      sameRole=contextual.filter(p=>!used.has(Number(p.id))&&roleOf(p)?.startsWith('outer_')&&roleOf(p)!==roleOf(anchor)&&weatherCompatible(p)&&quietFit(p)).map(p=>decorate(p,p.family==='solid'?90:88)).sort(order);
    }
    const substitutes=uniqueVariantFamilies(saved?restore(sameRole,saved.substitutes):distinct(sameRole,[],6,memory,'substitute'),6);
    const gearUtility=p=>{
      const season=cfg.context.season,raw=p.role,thermal=p.thermal,palette=p.palette||[];
      let utility=0;
      if(raw==='bag')utility+=4;
      if(season==='winter'){if(raw==='beanie')utility+=9;else if(thermal==='warm')utility+=6;else if(raw==='bag')utility+=3;}
      else if(season==='autumn'){if(raw==='beanie')utility+=6;if(thermal==='warm')utility+=5;if(raw==='cap'&&thermal==='light')utility+=3;if(raw==='bag')utility+=4;}
      else if(season==='spring'){if(raw==='cap'&&thermal==='light')utility+=7;if(raw==='bag')utility+=5;if(raw==='beanie')utility+=2;}
      else if(season==='summer'){if(raw==='cap'&&thermal==='light')utility+=9;if(raw==='bag')utility+=5;if(thermal==='warm')utility-=12;}
      if(cfg.context.activity==='boar'&&palette.includes('orange'))utility+=8;
      if(cfg.context.activity==='duck'&&p.terrains?.includes('wetland'))utility+=5;
      if(['woodcock','rabbit'].includes(cfg.context.activity)&&p.terrains?.includes('forest'))utility+=3;
      const state=p.demandState||engine.demand(p);
      if(state?.state==='observed')utility+=Math.max(0,(Number(state.score)-50)*.05)*Math.max(0,Math.min(1,Number(state.confidence)||0));
      return utility;
    };
    const gearPool=contextual.filter(p=>roleOf(p)==='accessory'&&!used.has(Number(p.id))&&weatherCompatible(p))
      .map(p=>({...decorate(p,90),fieldUtility:gearUtility(p)}))
      .sort((a,b)=>b.fieldUtility-a.fieldUtility||order(a,b));
    let accessories=[];
    if(saved?.accessories)accessories=restore(gearPool,saved.accessories).filter(p=>saved.accessories.includes(p.id)).slice(0,2);
    if(!accessories.length){
      const head=gearPool.find(p=>['cap','beanie'].includes(p.role));
      const bag=gearPool.find(p=>p.role==='bag');
      if(head)accessories.push(head);
      if(bag&&(!head||bag.id!==head.id))accessories.push(bag);
      if(accessories.length<2)accessories.push(...distinct(gearPool.filter(p=>!accessories.some(q=>q.id===p.id)),accessories,2-accessories.length,memory,'field-gear'));
    }
    accessories=accessories.slice(0,2);
    return {anchor,primary,companions,alternatives,totals,world,accessories,substitutes,substituteTotal:sameRole.length,strongCount:strong.length,candidateCount:cfg.profiles.length,composition:saved?.composition||compositionFor(roleOf(anchor),memory)};
  };
  const systemMerchandise=(cfg,engine,memory={},saved)=>{
    const anchor=engine.profile(cfg.productId),covered=new Set((anchor.covers||[]).map(r=>r.startsWith('outer_')?'outer':r));
    const open=['first_layer','mid_layer','vest','bottom','outer_light','outer_heavy','accessory'].filter(r=>!covered.has(r.startsWith('outer_')?'outer':r));
    const build=engine.rankSystem(anchor.id,cfg.profiles,'build').filter(p=>roleOf(p)!=='accessory');
    const world=engine.rankSystem(anchor.id,cfg.profiles,'world').filter(p=>roleOf(p)!=='accessory'&&p.family===anchor.family&&p.family!=='unknown');
    const compare=engine.rankSystem(anchor.id,cfg.profiles,'compare');
    const accessories=engine.rankSystem(anchor.id,cfg.profiles,'build').filter(p=>roleOf(p)==='accessory');
    const conditions=compare.filter(p=>['warm','light','hot'].includes(anchor.thermal)&&['warm','light','hot'].includes(p.thermal)&&p.thermal!==anchor.thermal&&p.family===anchor.family);
    const avg=rows=>rows.length?rows.reduce((n,p)=>n+p.score,0)/rows.length:0;
    const axis=(key,rows,extra)=>({key,rows,value:avg(rows.slice(0,3))+Math.min(4,rows.length)*.55+Math.min(3,new Set(rows.map(exposure)).size)*.8+(rows[0]?(rows[0].health.score-70)*.04+((rows[0].demandState?.score||50)-50)*.025+Math.min(3,cfg.media?.[rows[0].id]?.count||0)*.6-Math.min(2,fatigue(rows[0],memory,key)*.06):0)+extra});
    const axes=[axis('build',build,open.length>=4?3:0),axis('world',world,-2),axis('compare',compare,covered.size>=4?5:0),axis('conditions',conditions,-1),axis('accessory',accessories,-14)].filter(a=>a.rows.length);
    axes.sort((a,b)=>b.value-a.value);
    if(saved?.setAxes?.length){const order=saved.setAxes.map(a=>a.key);axes.sort((a,b)=>(order.includes(a.key)?order.indexOf(a.key):99)-(order.includes(b.key)?order.indexOf(b.key):99));}
    const available=[...new Set(axes.flatMap(a=>a.rows.map(p=>p.id)))];
    const used=new Set(),picked=[];let remaining=18;
    const restore=(rows,ids=[])=>[...rows].sort((a,b)=>{const ai=ids.indexOf(a.id),bi=ids.indexOf(b.id);return (ai<0?999:ai)-(bi<0?999:bi);});
    for(const [axisIndex,a] of axes.entries()){
      const pool=uniqueVariantFamilies(a.rows.filter(p=>!used.has(p.id)));if(!pool.length||!remaining)continue;
      const max=a.key==='accessory'?2:a.key==='conditions'?3:6;
      const preserve=saved?.setAxes?.find(x=>x.key===a.key);
      const exclusiveLater=new Set();for(const later of axes.slice(axisIndex+1)){const distinctLater=later.rows.filter(p=>!used.has(p.id)&&!pool.some(q=>q.id===p.id)&&!exclusiveLater.has(p.id));distinctLater.slice(0,2).forEach(p=>exclusiveLater.add(p.id));}
      const capacity=Math.min(max,Math.max(1,remaining-exclusiveLater.size));
      const selected=preserve?restore(pool,preserve.ids).slice(0,capacity):distinct(pool,[],capacity,memory,a.key==='compare'?'substitute':a.key==='world'?'same-world':'primary');
      if(!selected.length)continue;
      selected.forEach(p=>used.add(p.id));remaining-=selected.length;picked.push({...a,selected});
    }
    const depth=picked.length>=3&&used.size>=10?'DEEP':picked.length>=2&&used.size>=5?'MEDIUM':'SHORT';
    // Sets read best as: what to wear with it, other ready-made sets, then one quieter axis.
    // Nothing is tucked behind a disclosure; the "Daha fazlasını gör" sheet carries the long tail.
    const axisRank={build:0,compare:1,world:2,accessory:3,conditions:4};
    picked.sort((a,b)=>axisRank[a.key]-axisRank[b.key]);picked.splice(3);
    const get=key=>picked.find(a=>a.key===key)?.selected||[];
    const primary=[...get('build'),...get('conditions')],sameWorld=get('world'),substitutes=get('compare'),gear=get('accessory');
    const moments=picked.map((a,i)=>({type:a.key==='build'?(a.selected.length>=2&&exposure(a.selected[0])!==exposure(a.selected[1])?'visual-pair':'role-alternatives'):a.key==='world'?'field-cluster':a.key==='compare'?'substitute-compare':a.key==='accessory'?'compact-accessories':'conditions',axis:a.key,ids:a.selected.map(p=>p.id),intent:a.key==='world'?'same-world':a.key==='compare'?'substitute':a.key==='accessory'?'accessory':'complement',gesture:a.selected.length>2?'swipe':'tap',attention:i===0?3:2,depth:false}));
    return {anchor,coveredRoles:[...anchor.covers||[]],openRoles:open,primary,world:sameWorld,substitutes,accessories:gear,alternatives:new Map(),totals:new Map(),composition:'set-'+(picked[0]?.key||'world'),moments,setAxes:picked.map(a=>({key:a.key,ids:a.selected.map(p=>p.id)})),axisAudit:axes.map(a=>({key:a.key,available:a.rows.length,value:Math.round(a.value*10)/10})),strongCount:build.length,candidateCount:available.length,orchestration:{depth:'SET-'+depth,attention:moments.reduce((n,m)=>n+m.attention,0),swipes:moments.filter(m=>m.gesture==='swipe'&&!m.depth).length,breadth:used.size,coveredRoleCount:covered.size,openRoleCount:open.length}};
  };

  const mediaInfo=(p,cfg)=>cfg.media?.[p.id]||{count:0,geometry:'square',silhouette:roleOf(p)==='bottom'?'tall':'top'};
  const contextBias=(p,memory)=>Math.min(.65,(memory.visits||[]).slice(-4).reduce((n,v)=>n+(v.family&&v.family===p.family? .16:0)+(v.terrain&&p.terrains?.includes(v.terrain)? .05:0),0));
  const opportunity=(p,plan,cfg,memory)=>{
    const media=mediaInfo(p,cfg),choices=1+(plan.alternatives.get(p.id)||[]).length;
    const recipe=recipes[roleOf(plan.anchor)]||recipes.bottom,priority=Math.max(0,5-recipe.indexOf(roleOf(p)))*.65;
    const priceRatio=p.price/Math.max(1,plan.anchor.price),priceFit=priceRatio>=.25&&priceRatio<=1.6?.6:0;
    return p.score+(p.health.score-70)*.035+((p.demandState?.score??50)-50)*.025+Math.min(3,media.count)*.6+priority+priceFit+(media.silhouette==='tall'&&roleOf(plan.anchor)!=='bottom'?.2:0)+contextBias(p,memory)-Math.min(1.2,fatigue(p,memory,'primary')*.05)+(choices===1?.8:0);
  };
  const selectMoments=(plan,cfg,memory={})=>{
    const moments=[],rows=[...plan.primary];
    const make=(type,products,intent='complement',extra={})=>({type,ids:products.map(p=>p.id),intent,...extra});
    if(rows.length){
      const best=Math.max(...rows.map(p=>p.score));
      const finalists=rows.filter(p=>p.score>=best-3).sort((a,b)=>opportunity(b,plan,cfg,memory)-opportunity(a,plan,cfg,memory)||a.id-b.id);
      const lead=finalists[0],choices=[lead,...plan.alternatives.get(lead.id)||[]],near=choices.filter(p=>closeQuality(p,lead)),rich=mediaInfo(lead,cfg).count>=2;
      const exceptional=lead.score>=99&&lead.health.score>=85&&rich&&(near.length===1||opportunity(lead,plan,cfg,memory)-(finalists[1]?opportunity(finalists[1],plan,cfg,memory):0)>3);
      const partner=finalists.slice(1).find(p=>p.score>=95&&p.health.score>=70&&mediaInfo(p,cfg).count>=2&&rich&&exposure(p)!==exposure(lead)&&(mediaInfo(p,cfg).silhouette!==mediaInfo(lead,cfg).silhouette||p.pattern!==lead.pattern)&&Math.abs(opportunity(p,plan,cfg,memory)-opportunity(lead,plan,cfg,memory))<=3.2);
      if(exceptional)moments.push(make('hero-complement',[lead]));
      else if(near.length>=3)moments.push(make('role-alternatives',[lead], 'complement',{rail:true}));
      else if(partner)moments.push(make('visual-pair',[lead,partner]));
      else moments.push(make(rich&&lead.health.score>=70?'hero-complement':'role-alternatives',[lead]));
      const selected=new Set(moments[0].ids);
      for(const p of rows.filter(p=>!selected.has(p.id))){const choices=1+(plan.alternatives.get(p.id)||[]).length;moments.push(make('role-alternatives',[p],'complement',{rail:choices>=3,depth:true}));}
    }
    if(plan.world.length){
      const clothes=plan.world.filter(p=>roleOf(p)!=='accessory'),roles=new Set(clothes.map(exposure));
      const rich=clothes.filter(p=>mediaInfo(p,cfg).count>=2&&p.health.score>=70);
      const type=!clothes.length?'compact-accessories':roles.size>=2&&rich.length>=2?'field-cluster':rich.length>=1&&plan.world.length===2?'visual-pair':'field-cluster';
      const layout=!clothes.length?'compact':rich.length>=2&&roles.size>=2?'editorial':plan.world.length===2&&rich.length?'pair':'horizontal';
      moments.splice(Math.min(1,moments.length),0,make(type,plan.world,'same-world',{layout}));
    }
    if(plan.substitutes.length)moments.splice(Math.min(2,moments.length),0,make('substitute-compare',plan.substitutes,'substitute'));
    if(plan.accessories?.length)moments.push(make('compact-accessories',plan.accessories,'accessory',{depth:true}));
    return moments;
  };

  const decisionValue=(p,anchor)=>p.pattern!==anchor.pattern||p.thermal!==anchor.thermal||Math.abs(p.price-anchor.price)>=100;
  const orchestration=(plan,cfg,memory={},saved)=>{
    const avg=rows=>rows.length?rows.reduce((n,p)=>n+p,0)/rows.length:0;
    const safe=p=>p.health&&!p.health.suppressed&&p.health.score>=55&&mediaInfo(p,cfg).count>0;
    const strong=p=>safe(p)&&p.score>=95&&p.health.score>=70;
    const candidates=[...new Map([...plan.primary,...[...plan.alternatives.values()].flat(),...plan.world,...plan.substitutes,...plan.accessories||[]].filter(safe).map(p=>[p.id,p])).values()];
    const robust=candidates.filter(strong),roles=new Set(robust.filter(p=>roleOf(p)!=='accessory').map(exposure));
    const visits=(memory.visits||[]).slice(-4),repetition=Math.min(2,(memory.moments||[]).slice(-12).filter(m=>m.anchor!==plan.anchor.id&&candidates.some(p=>p.id===m.id)).length/4);
    const confidence=avg(robust.map(p=>p.score)),health=avg(robust.map(p=>p.health.score)),richness=avg(robust.map(p=>Math.min(3,mediaInfo(p,cfg).count)));
    const demand=avg(robust.map(p=>((p.demandState?.score??50)-50)*Math.min(1,p.demandState?.confidence||0)));
    const budgetValue=robust.length+roles.size*1.4+(confidence>=99?1:0)+(health>=85?1:0)+(richness>=2?1:0)+Math.min(.8,demand/30);
    const depth=robust.length>=10&&roles.size>=3&&budgetValue>=16?'deep':robust.length>=5&&roles.size>=2?'medium':'short';
    const limits={short:{open:2,total:2,attention:6,breadth:3,swipes:1},medium:{open:3,total:4,attention:9,breadth:4,swipes:1},deep:{open:4,total:6,attention:11,breadth:6,swipes:2}}[depth];
    const proposals=[],rank=p=>p.score+(p.health.score-70)*.035+((p.demandState?.score??50)-50)*.025*Math.min(1,p.demandState?.confidence||0)+Math.min(3,mediaInfo(p,cfg).count)*.45;
    const anchorRole=roleOf(plan.anchor),priority=p=>Math.max(0,4-(recipes[anchorRole]||[]).indexOf(roleOf(p)))*.32;
    const make=(type,rows,intent,extra={})=>{if(!rows.length)return;const ids=rows.map(p=>p.id);proposals.push({type,ids,intent,score:avg(rows.map(rank)),attention:type==='hero-complement'?4:type==='substitute-compare'?3:type==='visual-pair'?3:type==='compact-accessories'?1:2,...extra});};
    const main=plan.primary.filter(strong).sort((a,b)=>rank(b)+priority(b)-rank(a)-priority(a)||a.id-b.id);
    for(const p of main){
      const near=[p,...plan.alternatives.get(p.id)||[]].filter(q=>strong(q)&&closeQuality(q,p));
      make('role-alternatives',[p],'complement',{score:rank(p)+priority(p),rail:near.length>=3,choices:limits.breadth});
      if(p.score>=99&&p.health.score>=85&&mediaInfo(p,cfg).count>=2&&(near.length<=2||rank(p)-rank(main[1]||p)>2))make('hero-complement',[p],'complement',{score:rank(p)+priority(p)+2,choices:limits.breadth});
    }
    for(let i=0;i<main.length;i++)for(let j=i+1;j<main.length;j++){
      const a=main[i],b=main[j];if(mediaInfo(a,cfg).count<2||mediaInfo(b,cfg).count<2||Math.abs(rank(a)-rank(b))>4)continue;
      make('visual-pair',[a,b],'complement',{score:avg([rank(a)+priority(a),rank(b)+priority(b)])+1.5,choices:Math.min(3,limits.breadth)});
    }
    const world=plan.world.filter(p=>safe(p)&&p.score>=93&&p.connections?.length>=2||safe(p)&&p.serendipity&&p.score>=91).slice(0,depth==='short'?2:3);
    const clothes=world.filter(p=>roleOf(p)!=='accessory');
    if(world.length&&clothes.length){const rich=clothes.filter(p=>strong(p)&&mediaInfo(p,cfg).count>=2);make('field-cluster',world,'same-world',{layout:rich.length>=2?'editorial':world.length===2?'pair':'compact',score:avg(world.map(rank))+(anchorRole==='vest'?1.4:0)+(world.every(p=>p.connections?.includes('activity'))?1:0),novelty:world.filter(p=>p.serendipity).length});}
    const substitutes=plan.substitutes.filter(p=>safe(p)&&p.score>=92&&decisionValue(p,plan.anchor)).slice(0,limits.breadth);
    if(substitutes.length)make('substitute-compare',substitutes,'substitute',{rail:substitutes.length>2,score:avg(substitutes.slice(0,3).map(rank))+(anchorRole.startsWith('outer')?2:0)+Math.min(1.5,substitutes.length*.3)});
    const gear=[...plan.accessories||[],...(!clothes.length?world:[])].filter(p=>safe(p)&&p.score>=93).slice(0,2);
    make('compact-accessories',gear,'accessory');
    const selected=[],used=new Set();let attention=0,swipes=0,stages=0,novelty=0;
    const typeRepeats=m=>Math.min(1.6,(memory.layouts||[]).slice(-3).reduce((n,l)=>n+(l.types||[]).filter(t=>t===m.type).length*.55,0));
    const eligible=()=>proposals.filter(m=>m.score>=95&&!m.ids.some(id=>used.has(id))&&!(m.type==='hero-complement'&&stages)&&novelty+(m.novelty||0)<=1);
    while(selected.length<limits.total){
      const remaining=eligible();if(!remaining.length)break;
      const last=selected.at(-1),open=selected.filter(m=>!m.depth),late=visits.length>=2;
      const value=m=>m.score-(selected.some(n=>n.intent===m.intent)?1.6:0)-typeRepeats(m)*(late?1:.5)-(last?.attention>=3&&m.attention>=3?5:0)-(m.rail&&last?.gesture==='swipe'?3:0)+(selected.length===0&&m.type==='hero-complement'?1:0);
      remaining.sort((a,b)=>value(b)-value(a)||b.score-a.score||a.ids[0]-b.ids[0]);
      const chosen={...remaining[0]},defer=open.length>=limits.open||attention+chosen.attention>limits.attention||(late&&open.length>=2&&repetition>=1&&typeRepeats(chosen)>1);
      if(depth==='short'&&defer)break;
      chosen.depth=defer||selected.some(m=>m.depth);
      if(chosen.depth&&chosen.score<97)break;
      const prior=selected.at(-1);
      if(prior?.attention>=3&&chosen.attention>=3){chosen.presentation='compact';chosen.attention=2;}
      if(chosen.type==='hero-complement')stages++;
      const wantsSwipe=chosen.rail&&!chosen.depth;
      chosen.gesture=wantsSwipe&&swipes<limits.swipes&&prior?.gesture!=='swipe'?'swipe':'tap';
      if(chosen.gesture==='swipe')swipes++;
      if(!chosen.depth)attention+=chosen.attention;
      novelty+=chosen.novelty||0;chosen.ids.forEach(id=>used.add(id));selected.push(chosen);
    }
    const signature=selected.map(m=>m.type+':'+m.ids.join(',')).sort().join('|');
    if(saved?.orchestration?.version===6&&saved.orchestration.signature===signature&&saved.orchestration.depth===depth){
      const available=new Map(selected.map(m=>[m.type+':'+m.ids.join(','),m]));
      if(saved.moments?.length===selected.length)return {moments:saved.moments.map(m=>({...available.get(m.type+':'+m.ids.join(',')),depth:m.depth,gesture:m.gesture,presentation:m.presentation})),budget:{...saved.orchestration,restored:true}};
    }
    return {moments:selected,budget:{version:6,depth,signature,robust:robust.length,roles:roles.size,confidence,health,richness,demand,repetition,budgetValue,attention,swipes,novelty,limits,competition:proposals.length,omitted:proposals.filter(m=>!selected.some(n=>n.type===m.type&&n.ids.join(',')===m.ids.join(','))).map(m=>({type:m.type,score:Math.round(m.score*10)/10,reason:m.score<95?'quality':m.ids.some(id=>used.has(id))?'competing-products':'attention-or-depth'}))}};
  };

  const surfaceCache=new Map();
  const measureSurface=img=>{
    const url=new URL(img.currentSrc||img.src,location.href),key=url.origin+url.pathname+'?v='+(url.searchParams.get('v')||'');if(surfaceCache.has(key))return surfaceCache.get(key);
    try{
      const size=48,canvas=document.createElement('canvas');canvas.width=canvas.height=size;
      const ctx=canvas.getContext('2d',{willReadFrequently:true});ctx.drawImage(img,0,0,size,size);
      const d=ctx.getImageData(0,0,size,size).data,pixels=[];
      for(let y=0;y<size;y++)for(let x=0;x<size;x++)if((x<4||x>43)&&(y<4||y>43)){const i=(y*size+x)*4;pixels.push([d[i],d[i+1],d[i+2],d[i+3]]);}
      const transparent=pixels.filter(p=>p[3]<16).length>pixels.length*.55;
      const median=a=>a.sort((a,b)=>a-b)[Math.floor(a.length/2)],rgb=[0,1,2].map(c=>median(pixels.map(p=>p[c])));
      const neutral=p=>p[3]>245&&Math.min(...p.slice(0,3))>175&&Math.max(...p.slice(0,3))-Math.min(...p.slice(0,3))<30;
      const stable=pixels.filter(p=>neutral(p)&&Math.max(...rgb.map((c,i)=>Math.abs(c-p[i])))<25).length>pixels.length*.88;
      const studio=stable&&Math.min(...rgb)>175&&Math.max(...rgb)-Math.min(...rgb)<28;
      const edge=y=>{const row=[];for(let x=0;x<size;x++){const i=(y*size+x)*4;const pixel=[d[i],d[i+1],d[i+2],d[i+3]];if(neutral(pixel))row.push(pixel);}return row.length>size*.85?[0,1,2].map(c=>median(row.map(p=>p[c]))):rgb;};
      const color=c=>'rgb('+c.join(',')+')';const result={kind:transparent?'cutout':studio?'studio':'photo',color:studio?color(rgb):null,top:studio?color(edge(0)):null,bottom:studio?color(edge(size-1)):null,box:null,seamless:studio&&rgb.every((c,i)=>Math.abs(c-[243,240,232][i])<=6)};
      if(transparent||studio){
        let left=size,top=size,right=0,bottom=0,hits=0;
        for(let y=0;y<size;y++)for(let x=0;x<size;x++){const i=(y*size+x)*4,subject=transparent?d[i+3]>32:Math.max(...rgb.map((c,k)=>Math.abs(c-d[i+k])))>28;if(subject){left=Math.min(left,x);right=Math.max(right,x);top=Math.min(top,y);bottom=Math.max(bottom,y);hits++;}}
        if(hits>size*size*.06&&hits<size*size*.88&&left>0&&top>0&&right<size-1&&bottom<size-1)result.box={x:Math.max(0,left-2)/size,y:Math.max(0,top-2)/size,w:Math.min(size,right-left+5)/size,h:Math.min(size,bottom-top+5)/size};
      }
      if(surfaceCache.size>=120)surfaceCache.delete(surfaceCache.keys().next().value);surfaceCache.set(key,result);return result;
    }catch{return {kind:'natural',color:null,box:null};}
  };
  customElements.define('hs2-discovery',class extends HTMLElement{
    connectedCallback(){
      if(this.dataset.ready)return;
      if(this.hasAttribute('data-hs2-continuation')){this.continuationReady();return;}
      if(!this.dataset.hs2Booted&&'IntersectionObserver'in window){
        this.dataset.hs2Booted='waiting';
        this.bootObserver=new IntersectionObserver(entries=>{
          if(!entries.some(entry=>entry.isIntersecting))return;
          this.bootObserver?.disconnect();this.bootObserver=null;
          this.dataset.hs2Booted='true';
          if(this.isConnected)this.connectedCallback();
        },{rootMargin:'900px 0px',threshold:0});
        this.bootObserver.observe(this);
        return;
      }
      const config=this.querySelector('[data-hs2-config]');if(!config)return;
      try{
        this.cfg=JSON.parse(config.textContent);this.skipShownPattern();this.cfg.media=Object.fromEntries([...this.querySelectorAll('template[data-hs2-product]')].map(t=>{const d=t.content.firstElementChild.dataset;return [d.productId,{count:Number(d.mediaCount)||0,geometry:d.geometry,silhouette:d.silhouette}];}));this.cfg.now=Math.max(this.cfg.now,Date.now()/1000);this.engine=createHs2Intelligence(this.cfg);this.journey=journey(this.engine.profile(this.cfg.productId));if(this.cfg.setSystem){this.plan=systemMerchandise(this.cfg,this.engine,this.journey.input,this.journey.saved);}else{this.plan=merchandise(this.cfg,this.engine,this.journey.input,this.journey.saved);this.plan.moments=[];this.plan.orchestration={depth:'FIELD',attention:1,swipes:0};}
        this.templates=new Map([...this.querySelectorAll('template[data-hs2-product]')].map(t=>[Number(t.dataset.hs2Product),t]));this.liveObservers=new Map();
        this.dataset.anchorRole=roleOf(this.plan.anchor);this.dataset.anchorId=String(this.cfg.productId);this.dataset.partition=this.cfg.partition;this.dataset.generation='6';this.dataset.discoveryBudget=this.plan.orchestration.depth;this.dataset.attention=String(this.plan.orchestration.attention);this.dataset.swipes=String(this.plan.orchestration.swipes);this.dataset.moments=this.plan.moments.map(m=>m.type).join(',');this.dataset.composition=this.plan.composition;
        this.dataset.plannedIds=[...this.plan.primary,...[...this.plan.alternatives.values()].flat(),...this.plan.world,...this.plan.substitutes,...this.plan.accessories||[]].map(p=>p.id).join(',');
        this.dataset.strong=String(this.plan.strongCount||0);this.dataset.candidates=String(this.plan.candidateCount||0);
        this.render();for(const [i,rail] of [...this.querySelectorAll('.hs2__rail,.hs2__options')].entries())rail.scrollLeft=this.journey.saved?.rails?.[i]||0;this.journey.commit(this.plan);this.observeMoments();this.continuity();this.stickyLayout();this.dataset.ready='true';
      }catch(error){this.dataset.error='discovery-unavailable';console.warn('Hardstone 2 discovery unavailable',error.message);}
    }
    systemCompare(card,p){
      const facts=el('div','hs2__facts'),text=this.cfg.text;
      const roles=(p.covers||[]).map(r=>text['set_role_'+r]).filter(Boolean);
      if(roles.length)facts.append(el('span','hs2__fact',roles.join(' + ')));
      if(p.family!=='unknown'&&text['pattern_'+p.family])facts.append(el('span','hs2__fact',text['pattern_'+p.family]));
      if(p.thermal==='warm')facts.append(el('span','hs2__fact',text.set_warm));
      const delta=(p.price-this.plan.anchor.price)/100,amount=new Intl.NumberFormat(this.cfg.locale,{maximumFractionDigits:2}).format(Math.abs(delta));
      facts.append(el('strong','hs2__fact hs2__fact--price',delta===0?text.price_equal:(delta>0?'+':'−')+amount+' '+(this.cfg.currency||'TRY').replace('TRY','TL')));
      card.querySelector('.hs2-product__inspect').before(facts);
    }
    systemMoment(m,index){
      this.activeMoment=m;
      const lookup=new Map([...this.plan.primary,...this.plan.world,...this.plan.substitutes,...this.plan.accessories].map(p=>[p.id,p]));
      const rows=m.ids.map(id=>lookup.get(id)).filter(Boolean);if(!rows.length)return null;
      const label=this.cfg.text['set_'+m.axis],wrap=el('section','hs2__system-axis');let node;
      if(m.axis==='build'&&rows.length>=2&&exposure(rows[0])!==exposure(rows[1])&&rows[0].health.score>=70&&rows[1].health.score>=70){
        node=this.paired(rows.slice(0,2),'inner-pair',index);node.querySelector('.hs2__pair-head h2').textContent=label;
        node.querySelector('.hs2__eyebrow').textContent=this.cfg.text.set_open;
        if(rows.length>2){const more=this.shelf(rows.slice(2),this.cfg.text.set_more_layers,'set-layers');if(more)node.append(more);}
      }else if(m.axis==='build'&&rows.length===1&&rows[0].score>=97&&(this.cfg.media[rows[0].id]?.count||0)>=2){
        node=this.chapter(rows[0],'stage',index);node.querySelector('h2').textContent=label;
      }else if(m.axis==='world'&&new Set(rows.map(exposure)).size>=2){
        node=this.world({...m,ids:rows.slice(0,3).map(p=>p.id),layout:'editorial'});node.querySelector('h2').textContent=label;
        if(rows.length>3){const more=this.shelf(rows.slice(3),this.cfg.text.set_more_world,'set-world');if(more){more.dataset.intent='same-world';node.append(more);}}
      }else node=this.shelf(rows,label,m.axis==='compare'?'similar':m.axis==='accessory'?'accessories':'set-'+m.axis);
      if(!node)return null;node.dataset.intent=m.intent;
      wrap.dataset.axis=m.axis;wrap.dataset.discoveryMoment=m.type;wrap.dataset.intent=m.intent;wrap.dataset.gesture=m.gesture;wrap.dataset.attention=String(m.attention);wrap.dataset.momentPriority=index===0?'lead':'support';
      const subtitle=this.cfg.text['set_'+m.axis+'_note'];if(subtitle)wrap.append(el('p','hs2__system-note',subtitle));wrap.append(node);return wrap;
    }
    skipShownPattern(){
      // Products already shown in the same-pattern panel above are not repeated below.
      const key=h=>{try{return decodeURIComponent(h||'').normalize('NFC');}catch(e){return h||'';}};
      const shown=new Set([...document.querySelectorAll('[data-hs-pf-card][href]')].map(a=>key((a.getAttribute('href').split('?')[0].split('/products/')[1]))).filter(Boolean));
      if(!shown.size||!Array.isArray(this.cfg.profiles))return;
      this.cfg.profiles=this.cfg.profiles.filter(p=>String(p.id)===String(this.cfg.productId)||!shown.has(key(p.handle)));
    }
    renderSystem(){
      const stream=this.querySelector('[data-hs2-stream]'),fallback=this.querySelector('[data-hs2-set-fallback]'),plan=this.plan;
      if(!plan.moments.length){this.continuationReady();return;}
      stream.classList.add('hs2-fe','hs2-fe--system');

      const intro=el('section','hs2-fe__section hs2-fe-system-intro');
      const introHead=el('div','hs2-fe__head'),introCopy=el('div','');
      introCopy.append(el('span','hs2-fe__eyebrow','HARDSTONE'),el('h2','',this.cfg.text.set_intro));
      introHead.append(introCopy);intro.append(introHead);
      if(this.cfg.text.set_intro_note)intro.append(el('p','hs2-fe-system__intro-note',this.cfg.text.set_intro_note));
      stream.append(intro);

      const lookup=new Map([...plan.primary,...plan.world,...plan.substitutes,...plan.accessories].map(p=>[p.id,p]));
      const renderAxis=(m,index,parent)=>{
        const rows=m.ids.map(id=>lookup.get(id)).filter(Boolean).slice(0,m.axis==='accessory'?2:4);
        if(!rows.length)return null;
        const section=el('section','hs2-fe__section hs2-fe-products hs2-fe-products--system');
        section.dataset.intent=m.intent;section.dataset.axis=m.axis;section.dataset.discoveryMoment=m.type;section.dataset.momentPriority=index===0?'lead':'support';
        const head=el('div','hs2-fe__head'),copy=el('div','');
        const label=this.cfg.text['set_'+m.axis]||this.cfg.text.discovery;
        copy.append(el('h2','',label));
        const note=this.cfg.text['set_'+m.axis+'_note'];if(note)copy.append(el('p','hs2-fe-system__note',note));
        head.append(copy);section.append(head);
        const grid=el('div','hs2-fe-grid');
        for(const p of rows){
          const card=this.feProductCard(p,m.axis==='compare'?'substitute':m.axis==='accessory'?'accessory':'primary');
          card.dataset.hsStaggerItem='true';card.style.setProperty('--hs-stagger',Math.min(grid.children.length,7)*58+'ms');grid.append(card);
        }
        section.append(grid);parent.append(section);return section;
      };

      const open=plan.moments.filter(m=>!m.depth),deeper=plan.moments.filter(m=>m.depth);
      open.forEach((m,i)=>renderAxis(m,i,stream));

      if(deeper.length){
        const details=el('details','hs2-fe-system-depth'),summary=el('summary','hs2-fe-system-depth__summary');
        const copy=el('span','hs2-fe-system-depth__copy');
        copy.append(el('strong','',this.cfg.text.set_depth),el('span','',deeper.map(m=>this.cfg.text['set_'+m.axis]).filter(Boolean).join(' · ')));
        const affordance=el('span','hs2-fe-system-depth__affordance','↗');affordance.setAttribute('aria-hidden','true');
        summary.append(copy,affordance);details.append(summary);stream.append(details);
        const mount=()=>{
          if(!details.open||details.dataset.mounted)return;
          details.dataset.mounted='true';
          deeper.forEach((m,i)=>renderAxis(m,i+open.length,details));
          this.observeSystemEditorial(details);
        };
        details.addEventListener('toggle',()=>{this.journey.depth(details.open);mount();});
        if(this.journey.saved?.depthOpen){details.open=true;mount();}
      }

      const exit=open.some(m=>m.axis==='compare')?null:fallback?.querySelector('[data-hs2-system-exit]');
      if(exit){exit.classList.add('hs2-fe-system-exit');stream.append(exit);for(const img of exit.querySelectorAll('img'))this.media(img,img.parentElement);}
      fallback?.remove();

      this.dataset.openRoles=plan.openRoles.join(',');
      this.dataset.axisAudit=JSON.stringify(plan.axisAudit);
      this.dataset.discoveryBreadth=String(plan.orchestration.breadth);
      this.dataset.axes=plan.setAxes.map(a=>a.key).join(',');
      this.observeSystemEditorial(stream);
    }
    observeSystemEditorial(root){
      if(reduced()||!('IntersectionObserver'in window))return;
      const sections=[...root.querySelectorAll('.hs2-fe__section')].filter(section=>!section.dataset.hsObserved);
      if(!sections.length)return;
      if(!this.systemEditorialObserver){
        this.systemEditorialObserver=new IntersectionObserver(entries=>{
          for(const entry of entries)if(entry.isIntersecting){
            entry.target.dataset.hsEntered='true';
            delete entry.target.dataset.hsMotionPending;
            this.systemEditorialObserver.unobserve(entry.target);
          }
        },{threshold:.12,rootMargin:'0px 0px -6% 0px'});
      }
      for(const section of sections){
        section.dataset.hsObserved='true';section.dataset.hsMotionPending='true';
        this.systemEditorialObserver.observe(section);
      }
    }

    continuationReady(){
      this.liveObservers=new Map();
      for(const img of this.querySelectorAll('[data-hs2-visual] img,.hs2-product__media img'))this.media(img,img.parentElement);
      this.stickyLayout();
      if(!reduced()&&'IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>{for(const entry of entries)if(entry.isIntersecting){entry.target.dataset.motion='quiet';entry.target.classList.add('hs2__settle');this.observer.unobserve(entry.target);}},{threshold:.08});for(const moment of this.querySelectorAll('[data-discovery-moment]'))this.observer.observe(moment);}
      this.dataset.ready='true';
    }
    media(img,frame){
      img.crossOrigin='anonymous';img.decoding='async';frame.classList.add('hs2-media');
      const owner=frame.closest('.hs2-product');if(owner){frame.dataset.silhouette=owner.dataset.silhouette;frame.dataset.geometry=owner.dataset.geometry;}
      const fit=()=>{
        if(!img.complete||!img.naturalWidth||!img.isConnected)return;
        const w=frame.clientWidth,h=frame.clientHeight;if(!w||!h)return;
        const result=measureSurface(img),scale=w<=120?'micro':w<=190?'small':w<=320?'medium':'large';
        frame.dataset.mediaScale=scale;frame.dataset.surface=result.kind;
        const card=frame.closest('.hs2-product');const color=result.color||'transparent';
        for(const n of [frame,card].filter(Boolean)){
          n.dataset.surface=result.kind;n.style.setProperty('--media-surface',color);
          for(const edge of ['top','bottom'])n.style.setProperty('--media-'+edge,result[edge]||color);
        }
        const chapter=card?.closest('.hs2__field,.hs2__stage');if(chapter){chapter.dataset.surface=result.kind;chapter.style.setProperty('--chapter-surface',color);}
        frame.dataset.integration=result.kind==='cutout'?'transparent':result.kind==='studio'?(result.seamless?'seamless':'tonal'):'contained';
        img.removeAttribute('style');delete img.dataset.fitted;
        if(result.box){
          const b=result.box,iw=img.naturalWidth,ih=img.naturalHeight,base=Math.min(w/iw,h/ih),small=scale==='small'||scale==='micro';
          const edge=small?.97:.96,cap=small?1.6:1.32;
          const fitted=Math.min(w/(b.w*iw),h/(b.h*ih),base*cap)*edge,rw=iw*fitted,rh=ih*fitted;
          img.style.cssText='width:'+rw+'px;height:'+rh+'px;left:'+(w/2-(b.x+b.w/2)*rw)+'px;top:'+(h/2-(b.y+b.h/2)*rh)+'px;';img.dataset.fitted='true';
        }
      };
      img.addEventListener('load',fit);requestAnimationFrame(fit);
      if('ResizeObserver'in window&&matchMedia('(min-width:750px)').matches){this.liveObservers.get(frame)?.disconnect();const ro=new ResizeObserver(fit);ro.observe(frame);this.liveObservers.set(frame,ro);}
    }
    thumbnail(id,frame){
      const t=this.querySelector('template[data-hs2-thumb="'+id+'"]');if(!t)return;
      const img=t.content.firstElementChild.cloneNode(true),source=this.templates.get(Number(id))?.content.firstElementChild;
      frame.dataset.silhouette=source?.dataset.silhouette||'top';frame.dataset.geometry=source?.dataset.geometry||'square';
      frame.append(img);this.media(img,frame);
    }
    card(p,angle=false){
      const t=this.templates.get(Number(p.id));if(!t)return null;
      const card=t.content.firstElementChild.cloneNode(true);card.querySelector('[data-hs2-role]').textContent=this.cfg.text[roleOf(p)]||'';
      const img=card.querySelector('.hs2-product__image');img.sizes='auto';this.media(img,card.querySelector('.hs2-product__media'));
      if(angle&&roleOf(p)!=='accessory')this.addAngle(card,p);
      return card;
    }
    settle(n,direction=1){if(!reduced()&&n?.animate)n.animate([{opacity:.35,transform:'translateX('+direction*9+'px)'},{opacity:1,transform:'none'}],{duration:300,easing:'cubic-bezier(.22,.7,.2,1)'});}
    addAngle(card,p){
      const controls=el('div','hs2__media-controls');card.prepend(controls);const t=this.querySelector('template[data-hs2-angle="'+p.id+'"]');if(!t)return;
      const button=el('button','hs2__angle',this.cfg.text.angle);button.type='button';button.setAttribute('aria-pressed','false');
      const frame=card.querySelector('.hs2-product__media'),primary=frame.firstElementChild.cloneNode(true);
      button.addEventListener('click',()=>{
        const second=button.getAttribute('aria-pressed')!=='true',img=(second?t.content.firstElementChild:primary).cloneNode(true);img.removeAttribute('style');delete img.dataset.fitted;
        frame.style.removeProperty('--media-surface');card.style.removeProperty('--media-surface');frame.replaceChildren(img);this.media(img,frame);
        button.setAttribute('aria-pressed',String(second));button.textContent=second?this.cfg.text.front:this.cfg.text.angle;this.settle(frame);
      });controls.append(button);
    }
    exit(p){const url=this.templates.get(Number(p.id))?.content.firstElementChild.dataset.collection;if(!url||url==='/collections/all')return null;const a=el('a','hs2__exit',this.cfg.text['browse_'+roleOf(p)]||this.cfg.text.browse);a.href=url;a.append(el('span','','→'));return a;}
    destination(p){
      const link=this.exit(p);if(!link)return null;
      const title=this.templates.get(Number(p.id))?.content.firstElementChild.dataset.collectionTitle||link.firstChild.textContent,url=link.getAttribute('href'),seen=new Set(),previews=[];
      const choices=[p,...this.plan.alternatives.get(p.id)||[],...this.plan.substitutes,...this.plan.primary,...this.plan.world];
      for(const candidate of choices){const id=Number(candidate.id),source=this.templates.get(id)?.content.firstElementChild;if(seen.has(id)||source?.dataset.collection!==url)continue;seen.add(id);previews.push(id);if(previews.length===3)break;}
      link.className='hs2__destination';link.replaceChildren();
      const art=el('span','hs2__destination-art');art.setAttribute('aria-hidden','true');art.dataset.count=String(previews.length);
      for(const id of previews){const frame=el('span','hs2__destination-media');frame.dataset.previewId=String(id);this.thumbnail(id,frame);art.append(frame);}
      const copy=el('span','hs2__destination-copy');copy.append(el('strong','',title),el('span','',this.cfg.text.browse));
      const arrow=el('span','hs2__destination-arrow','↗');arrow.setAttribute('aria-hidden','true');link.append(art,copy,arrow);return link;
    }
    continuation(parent,rail,p,total,count){
      if(total<=count||count<3)return;
      const a=this.exit(p);if(!a)return;a.dataset.waiting='true';a.setAttribute('aria-hidden','true');a.tabIndex=-1;parent.append(a);
      const reveal=()=>{if(rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-28){delete a.dataset.waiting;a.removeAttribute('aria-hidden');a.removeAttribute('tabindex');rail.removeEventListener('scroll',reveal);}};
      rail.addEventListener('scroll',reveal,{passive:true});requestAnimationFrame(reveal);
    }
    selector(p,chapter,slot,kind){
      const others=this.plan.alternatives.get(p.id)||[];if(!others.length)return;
      const limit=this.activeMoment?.gesture==='swipe'?(this.activeMoment.choices||6):Math.min(3,this.activeMoment?.choices||3),rows=[p,...others].slice(0,limit),selector=el('div','hs2__selector'),head=el('div','hs2__selector-head');
      head.append(el('p','',this.cfg.text.alternatives));const count=el('span','hs2__position hs2__status','1 / '+rows.length);head.append(count);selector.append(head);
      const rail=el('div','hs2__options');rail.setAttribute('role','group');rail.setAttribute('aria-label',this.cfg.text.alternatives+' · '+this.cfg.text[roleOf(p)]);
      const status=el('span','hs2__status');status.setAttribute('aria-live','polite');let active=Math.max(0,rows.findIndex(q=>q.id===this.journey.saved?.selected?.[p.id]));if(active){const restored=this.card(rows[active],kind!=='compact');if(restored){slot.replaceChildren(restored);chapter.dataset.activeId=String(rows[active].id);count.textContent=(active+1)+' / '+rows.length;}}
      slot.id='hs2-slot-'+p.id;
      rows.forEach((q,index)=>{
        const b=el('button','hs2__option');b.type='button';b.dataset.optionId=String(q.id);b.setAttribute('aria-pressed',String(index===active));b.setAttribute('aria-controls',slot.id);b.setAttribute('aria-label',q.title+' · '+this.cfg.text.show);
        const visual=el('span','hs2__option-media');this.thumbnail(q.id,visual);b.append(visual,el('span','hs2__option-name',q.title));
        const source=this.templates.get(Number(q.id))?.content.querySelector('.hs2-product__price');if(source)b.append(el('span','hs2__option-price',source.textContent.trim()));
        b.addEventListener('click',()=>{
          if(active===index)return;const card=this.card(q,kind!=='compact');if(!card)return;
          const prior=slot.getBoundingClientRect().height;slot.style.minHeight=prior+'px';for(const old of slot.querySelectorAll('.hs2-product__media')){this.liveObservers.get(old)?.disconnect();this.liveObservers.delete(old);}slot.replaceChildren(card);chapter.dataset.activeId=String(q.id);this.watchCard(card,'primary');this.journey.select(p.id,q.id);
          rail.querySelectorAll('button').forEach(btn=>btn.setAttribute('aria-pressed',String(btn===b)));count.textContent=(index+1)+' / '+rows.length;
          status.textContent=q.title+' · '+card.querySelector('.hs2-product__price').textContent.trim();this.settle(slot,index>active?1:-1);active=index;
          const left=b.getBoundingClientRect().left-rail.getBoundingClientRect().left+rail.scrollLeft;
          if(left<rail.scrollLeft||left+b.offsetWidth>rail.scrollLeft+rail.clientWidth)rail.scrollTo({left:left-18,behavior:reduced()?'auto':'smooth'});
        });rail.append(b);
      });
      const cue=this.railCue(rows.length);head.append(cue.node);rail.querySelectorAll('button').forEach((b,i)=>b.addEventListener('click',()=>cue.select(i)));cue.select(active);selector.append(rail,status);if(this.activeMoment?.gesture==='swipe')this.continuation(selector,rail,p,this.plan.totals.get(p.id),rows.length);else if((this.plan.totals.get(p.id)||0)>rows.length){const exit=this.exit(p);if(exit)selector.append(exit);}chapter.append(selector);
    }
    chapter(p,kind,index){
      const section=el('section','hs2__chapter hs2__'+kind);section.dataset.need=roleOf(p);section.dataset.activeId=String(p.id);section.dataset.intent='complement';section.setAttribute('aria-label',this.cfg.text[roleOf(p)]);
      const sign=el('div','hs2__sign');sign.append(el('span','hs2__serial',String(index+1).padStart(2,'0')),el('h2','',this.cfg.text[roleOf(p)]),el('span','hs2__sign-arrow','↗'));section.append(sign);
      const slot=el('div','hs2__slot'),card=this.card(p,kind!=='compact');section.dataset.density=kind==='compact'?'support':p.score>=95?'strong':'support';if(card)slot.append(card);section.append(slot);this.selector(p,section,slot,kind);return section;
    }
    railCue(count){
      const node=el('span','hs2__rail-cue');node.setAttribute('aria-hidden','true');for(let i=0;i<count;i++)node.append(el('i',''));
      return {node,select:index=>[...node.children].forEach((n,i)=>n.dataset.current=String(index===i))};
    }
    shelf(rows,label,kind,total=rows.length){
      if(!rows.length)return null;
      const section=el('section','hs2__shelf hs2__shelf--'+kind);section.dataset.intent=kind==='similar'?'substitute':'complement';const head=el('div','hs2__shelf-head');head.append(el('h2','',label));
      const rail=el('div','hs2__rail');rail.setAttribute('aria-label',label);rail.tabIndex=0;
      for(const p of rows){const card=this.card(p);if(card){if(kind==='similar')this.compare(card,p);rail.append(card);}}
      if(kind==='similar'){
        const anchor=el('p','hs2__compare-anchor');anchor.append(el('span','',this.cfg.text.compare_with),el('strong','',this.plan.anchor.title));section.append(anchor);
      }
      if(rows.length>1&&this.activeMoment?.gesture==='swipe'){
        const control=el('div','hs2__rail-control'),cue=this.railCue(rows.length),next=el('button','hs2__next','→'),status=el('span','hs2__status');status.setAttribute('aria-live','polite');next.type='button';next.setAttribute('aria-label',this.cfg.text.next);let current=-1,pending=false;
        const update=()=>{pending=false;const cards=[...rail.children],left=rail.getBoundingClientRect().left+parseFloat(getComputedStyle(rail).paddingLeft||0),atEnd=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-12;let index=atEnd?cards.length-1:cards.reduce((best,n,i)=>Math.abs(n.getBoundingClientRect().left-left)<Math.abs(cards[best].getBoundingClientRect().left-left)?i:best,0);if(index!==current){current=index;cue.select(index);cards.forEach((n,i)=>n.dataset.current=String(i===index));status.textContent=rows[index].title;section.dataset.currentProduct=String(rows[index].id);}next.disabled=atEnd;};
        next.addEventListener('click',()=>{const target=rail.children[Math.min(rows.length-1,current+1)];if(target)rail.scrollTo({left:target.offsetLeft-rail.firstElementChild.offsetLeft,behavior:reduced()?'auto':'smooth'});});
        rail.addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(update);}},{passive:true});rail.addEventListener('keydown',event=>{if(event.target!==rail||!['ArrowLeft','ArrowRight'].includes(event.key))return;event.preventDefault();const i=Math.max(0,Math.min(rows.length-1,current+(event.key==='ArrowRight'?1:-1))),target=rail.children[i];rail.scrollTo({left:target.offsetLeft-rail.firstElementChild.offsetLeft,behavior:reduced()?'auto':'smooth'});});
        control.append(cue.node,next,status);head.append(control);requestAnimationFrame(update);
      }
      section.prepend(head);section.append(rail);if(this.activeMoment?.gesture==='swipe')this.continuation(section,rail,rows[0],total,rows.length);else if(total>rows.length){const exit=this.exit(rows[0]);if(exit)section.append(exit);}return section;
    }
    world(moment){
      const rows=this.plan.world.filter(p=>moment.ids.includes(p.id));if(!rows.length)return null;
      const section=el('section','hs2__world');section.dataset.intent='same-world';section.dataset.worldLayout=moment.layout;
      const head=el('div','hs2__world-head'),lens=rows.flatMap(p=>p.connections||[]).find(c=>c!=='pattern'&&c!=='palette')||'terrain';section.dataset.connection=lens;head.append(el('span','hs2__eyebrow',this.cfg.text['world_'+lens]||this.cfg.text.world_context),el('h2','',this.cfg.text.world));section.append(head);
      const clothes=rows.filter(p=>roleOf(p)!=='accessory'),small=rows.filter(p=>roleOf(p)==='accessory');
      const composition=el('div',moment.layout==='horizontal'?'hs2__rail hs2__world-rail':'hs2__world-composition');composition.dataset.smallCount=String(small.length);composition.dataset.clothesCount=String(clothes.length);composition.dataset.layout=moment.layout;
      if(moment.layout==='horizontal'){composition.tabIndex=0;composition.setAttribute('aria-label',this.cfg.text.world);}
      for(const p of [...clothes,...small]){const card=this.card(p);if(card){const connection=p.connections?.find(c=>c!==lens)||lens;card.querySelector('[data-hs2-role]').textContent=this.cfg.text['world_'+connection]||this.cfg.text[roleOf(p)];if(p.serendipity)card.dataset.serendipity='true';composition.append(card);}}
      section.append(composition);return section;
    }
    compare(card,p){
      if(this.cfg.setSystem&&p.system){this.systemCompare(card,p);return;}
      const facts=el('div','hs2__facts'),text=this.cfg.text,anchor=this.plan.anchor;
      const pattern=text['pattern_'+p.family];if(pattern)facts.append(el('span','hs2__fact',isExactPattern(p,anchor)?text.same_pattern:pattern));
      const seasons=[...new Set(p.seasons||[])],known=seasons.map(v=>text['season_'+v]).filter(Boolean);if(known.length){const label=seasons.length===4&&known.length===4?text.season_all:seasons.length===2&&seasons.includes('autumn')&&seasons.includes('winter')?text.season_cold:known.join(' · ');facts.append(el('span','hs2__fact',label));}
      if(Number.isFinite(p.price)&&Number.isFinite(anchor.price)){
        const difference=(p.price-anchor.price)/100,formatted=new Intl.NumberFormat(this.cfg.locale||'tr-TR',{minimumFractionDigits:0,maximumFractionDigits:2}).format(Math.abs(difference));facts.append(el('strong','hs2__fact hs2__fact--price',difference===0?text.price_equal:(difference>0?'+':'−')+formatted+' '+(this.cfg.currency||'TRY').replace('TRY','TL')));
      }
      if(facts.children.length){facts.setAttribute('aria-label',text.compare_price);card.querySelector('.hs2-product__inspect').before(facts);}
    }
    paired(rows,kind,index){
      const group=el('section','hs2__pair hs2__pair--'+kind);group.dataset.composition=kind;group.setAttribute('aria-label',this.cfg.text[kind.startsWith('inner')?'pair_inner':kind.startsWith('weather')?'pair_weather':'pair_field']);
      const header=el('div','hs2__pair-head');header.append(el('span','hs2__eyebrow',this.cfg.text[roleOf(this.plan.anchor)]),el('h2','',group.getAttribute('aria-label')));group.append(header);
      const grid=el('div','hs2__pair-grid');rows.forEach((p,i)=>{const chapter=this.chapter(p,'paired',index+i);grid.append(chapter);});group.append(grid);return group;
    }
    observeMoments(){
      if(!('IntersectionObserver'in window))return;
      this.momentObserver=new IntersectionObserver(entries=>{for(const entry of entries)if(entry.isIntersecting&&entry.intersectionRatio>=.35){const card=entry.target;this.journey.impression(this.engine.profile(Number(card.dataset.productId)),card.dataset.moment||'explore');this.momentObserver.unobserve(card);}},{threshold:[.35]});
      for(const card of this.querySelectorAll('[data-hs2-stream] .hs2-product,[data-hs2-stream] .hs2-fe-card'))this.watchCard(card);
    }
    watchCard(card,kind){
      card.dataset.moment=kind||(card.closest('[data-intent="same-world"]')?'same-world':card.closest('[data-intent="substitute"]')?'substitute':card.closest('.hs2__slot')?'primary':'explore');this.momentObserver?.observe(card);
    }
    continuity(){
      const key='hs2-transition-v4';let cue;try{cue=JSON.parse(sessionStorage.getItem(key)||'null');sessionStorage.removeItem(key);}catch{}
      if(cue?.id===this.cfg.productId&&Date.now()-cue.at<20000&&!reduced()){
        const intro=this.querySelector('.hs2__intro');if(intro)this.settle(intro);
      }
      this.addEventListener('click',event=>{
        const link=event.target.closest('.hs2-product__link');if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
        const card=link.closest('.hs2-product,.hs2-fe-card');if(!card)return;try{sessionStorage.setItem(key,JSON.stringify({id:Number(card.dataset.productId),at:Date.now()}));}catch{}
        this.journey.impression(this.engine.profile(Number(card.dataset.productId)),card.dataset.moment||'explore');card.classList.add('hs2__depart');
      });
      this.onPageShow=()=>this.querySelectorAll('.hs2__depart').forEach(card=>card.classList.remove('hs2__depart'));window.addEventListener('pageshow',this.onPageShow);this.onPageHide=()=>this.journey.navigation([...this.querySelectorAll('.hs2__rail,.hs2__options')].map(n=>Math.round(n.scrollLeft)));window.addEventListener('pagehide',this.onPageHide);
    }
    moment(m,index){
      if(this.cfg.setSystem)return this.systemMoment(m,index);
      this.activeMoment=m;
      const lookup=new Map([...this.plan.primary,...this.plan.world,...this.plan.substitutes,...this.plan.accessories||[]].map(p=>[p.id,p]));const rows=m.ids.map(id=>lookup.get(id)).filter(Boolean);if(!rows.length)return null;let node;
      if(m.intent==='same-world')node=this.world(m);
      else if(m.type==='compact-accessories')node=this.shelf(rows,this.cfg.text.accessory,'accessories');
      else if(m.type==='substitute-compare')node=this.shelf(m.gesture==='swipe'?rows:rows.slice(0,2),this.cfg.text.similar,'similar',this.plan.substituteTotal);
      else if(m.type==='visual-pair')node=this.paired(rows,this.plan.composition,index);
      else if(m.type==='hero-complement')node=this.chapter(rows[0],roleOf(rows[0])==='bottom'?'field':'stage',index);
      else{const p=rows[0],choices=[p,...this.plan.alternatives.get(p.id)||[]];node=m.rail&&m.gesture==='swipe'?this.shelf(choices.slice(0,m.choices||6),this.cfg.text[roleOf(p)],'explore',this.plan.totals.get(p.id)):this.chapter(p,'compact',index);}
      if(node){node.dataset.gesture=m.gesture;node.dataset.attention=String(m.attention);if(m.presentation)node.dataset.presentation=m.presentation;node.dataset.discoveryMoment=m.type;node.dataset.momentPriority=m.depth?'support':index===0?'lead':'support';}return node;
    }
    feRoleLabel(p){
      const role=roleOf(p);
      return ({bottom:'PANTOLON',first_layer:'İLK KATMAN',mid_layer:'ISI KATMANI',outer_light:'KORUYUCU DIŞ KATMAN',outer_heavy:'SICAK DIŞ KATMAN',vest:'YELEK',accessory:'SAHA EKİPMANI'}[role]||String(this.cfg.text[role]||role||'').toUpperCase());
    }
    feRoleRank(p){
      return ({bottom:0,first_layer:1,mid_layer:2,vest:2.5,outer_light:3,outer_heavy:4,accessory:6}[roleOf(p)]??9);
    }
    fePrice(p){
      const source=this.templates.get(Number(p.id))?.content.querySelector('.hs2-product__price');
      return source?.textContent?.trim()||'';
    }
    feTerrain(p){
      const value=p?.terrains?.[0];
      return ({forest:'Orman',wetland:'Sazlık',mixed:'Karma Arazi',mountain:'Dağ',open:'Açık Arazi'}[value]||'');
    }
    feDifference(p){
      const anchor=this.plan.anchor,text=this.cfg.text;
      if(p.family&&p.family!=='unknown'&&p.family!==anchor.family&&text['pattern_'+p.family])return 'DESEN · '+text['pattern_'+p.family];
      const terrain=this.feTerrain(p);if(terrain)return 'ARAZİ · '+terrain;
      const seasons=(p.seasons||[]).map(v=>text['season_'+v]).filter(Boolean);if(seasons.length)return 'SEZON · '+seasons.slice(0,2).join(' · ');
      return '';
    }
    feAnchorThumb(frame){
      const t=this.querySelector('template[data-hs2-anchor-thumb]');
      const img=t?.content?.querySelector('img')?.cloneNode(true);
      if(!img)return;
      frame.append(img);
      this.media(img,frame);
    }
    feProductCard(p,kind){
      const card=el('article','hs2-fe-card');card.dataset.productId=String(p.id);card.dataset.kind=kind||'explore';
      const link=el('a','hs2-product__link hs2-fe-card__link');link.href=p.url;
      const media=el('span','hs2-fe-card__media');this.thumbnail(p.id,media);
      const copy=el('span','hs2-fe-card__copy'),fact=this.feDifference(p);if(fact)copy.append(el('span','hs2-fe-card__fact',fact));
      copy.append(el('strong','',p.title));const price=this.fePrice(p);if(price)copy.append(el('span','hs2-fe-card__price',price));
      link.append(media,copy);card.append(link);return card;
    }
    renderFieldEditorial(){
      const stream=this.querySelector('[data-hs2-stream]'),plan=this.plan,anchor=plan.anchor;if(!stream||!anchor)return;
      stream.classList.add('hs2-fe');

      const axisKey=p=>roleOf(p),seen=new Set(),allRows=[];
      const source=[anchor,...plan.primary].sort((a,b)=>this.feRoleRank(a)-this.feRoleRank(b));
      for(const p of source){
        const key=axisKey(p);
        if(!key||seen.has(key))continue;
        seen.add(key);allRows.push(p);
      }

      const upperStackRoles=new Set(['first_layer','mid_layer','outer_light','outer_heavy']);
      const fullStackRoles=new Set(['bottom','first_layer','mid_layer','outer_light','outer_heavy']);
      const anchorRole=roleOf(anchor);
      const splitAxis=upperStackRoles.has(anchorRole);
      const layerRows=splitAxis
        ? allRows.filter(p=>upperStackRoles.has(roleOf(p)))
        : anchorRole==='vest'
          ? allRows.filter(p=>upperStackRoles.has(roleOf(p))||roleOf(p)==='vest')
          : allRows.filter(p=>fullStackRoles.has(roleOf(p)));
      const sameExact=(a,b)=>Boolean(a?.exactPattern&&b?.exactPattern&&a.exactPattern===b.exactPattern),companionSeen=new Set([Number(anchor.id)]);
      const companionRows=[...(plan.companions||[]),...(plan.primary||[])].filter(p=>{const id=Number(p.id);if(companionSeen.has(id))return false;companionSeen.add(id);return true;}).sort((a,b)=>Number(sameExact(b,anchor))-Number(sameExact(a,anchor))).slice(0,4);

      if(layerRows.length>1){
        const section=el('section','hs2-fe__section hs2-fe-layer-map');section.dataset.intent='complement';
        const head=el('div','hs2-fe__head'),headCopy=el('div','');
        headCopy.append(el('span','hs2-fe__eyebrow','HARDSTONE'),el('h2','','Katman Sistemi'));
        head.append(headCopy);section.append(head);

        const axis=el('div','hs2-fe-axis');
        for(const p of layerRows){
          const current=Number(p.id)===Number(anchor.id),row=el('div','hs2-fe-layer');
          row.dataset.current=String(current);row.dataset.role=roleOf(p);
          const node=el('span','hs2-fe-layer__node');node.setAttribute('aria-hidden','true');row.append(node);
          const content=el('div','');
          content.append(el('span','hs2-fe-layer__role',this.feRoleLabel(p)));
          if(current){
            const box=el('div','hs2-fe-layer__current');
            const media=el('span','hs2-fe-layer__current-media');this.feAnchorThumb(media);
            const copy=el('span','hs2-fe-layer__current-copy');
            copy.append(el('span','','BU ÜRÜN'),el('strong','',anchor.title),el('small','','Şu anda incelediğiniz katman'));
            box.append(media,copy);content.append(box);
          }else{
            const card=el('article','hs2-fe-card hs2__slot');card.dataset.productId=String(p.id);card.dataset.kind='primary';
            const link=el('a','hs2-product__link hs2-fe-layer__link');link.href=p.url;
            const media=el('span','hs2-fe-layer__media');this.thumbnail(p.id,media);
            const copy=el('span','hs2-fe-layer__copy');copy.append(el('strong','',p.title));
            const meta=el('span','hs2-fe-layer__meta');
            if(isExactPattern(p,anchor))meta.append(el('span','hs2-fe-layer__tag','AYNI DESEN'));
            const price=this.fePrice(p);if(price)meta.append(el('span','',price));
            if(meta.children.length)copy.append(meta);
            link.append(media,copy,el('span','hs2-fe-layer__arrow','→'));card.append(link);content.append(card);
          }
          row.append(content);axis.append(row);
        }
        section.append(axis);

        if(companionRows.length){
          const parallel=el('div','hs2-fe-parallel');
          parallel.append(el('span','hs2-fe-parallel__label','Birlikte giyilenler'));
          const grid=el('div','hs2-fe-parallel__grid');
          for(const p of companionRows){
            const card=el('article','hs2-fe-parallel__card hs2-fe-card hs2__slot');
            card.dataset.productId=String(p.id);card.dataset.kind='primary';
            const link=el('a','hs2-product__link hs2-fe-parallel__link');link.href=p.url;
            const media=el('span','hs2-fe-parallel__media');this.thumbnail(p.id,media);
            const copy=el('span','hs2-fe-parallel__copy');
            copy.append(el('span','hs2-fe-parallel__role',this.feRoleLabel(p)),el('strong','',p.title));
            const price=this.fePrice(p);if(price)copy.append(el('span','hs2-fe-parallel__price',price));
            link.append(media,copy);card.append(link);grid.append(card);
          }
          parallel.append(grid);section.append(parallel);
        }

        stream.append(section);
        if(!reduced()&&'IntersectionObserver'in window){
          const current=axis.querySelector('[data-current="true"]');
          if(current){
            const observer=new IntersectionObserver(entries=>{
              for(const entry of entries)if(entry.isIntersecting){
                current.dataset.focus='true';observer.disconnect();
              }
            },{threshold:.55});
            observer.observe(current);this.fieldObserver=observer;
          }
        }
      }
      if(layerRows.length<=1&&companionRows.length){
        const section=el('section','hs2-fe__section hs2-fe-companions-standalone');section.dataset.intent='complement';
        const head=el('div','hs2-fe__head');head.append(el('h2','','Birlikte giyilenler'));section.append(head);
        const grid=el('div','hs2-fe-parallel__grid');
        for(const p of companionRows){
          const card=el('article','hs2-fe-parallel__card hs2-fe-card hs2__slot');
          card.dataset.productId=String(p.id);card.dataset.kind='primary';
          const link=el('a','hs2-product__link hs2-fe-parallel__link');link.href=p.url;
          const media=el('span','hs2-fe-parallel__media');this.thumbnail(p.id,media);
          const copy=el('span','hs2-fe-parallel__copy');
          copy.append(el('span','hs2-fe-parallel__role',this.feRoleLabel(p)),el('strong','',p.title));
          const price=this.fePrice(p);if(price)copy.append(el('span','hs2-fe-parallel__price',price));
          link.append(media,copy);card.append(link);grid.append(card);
        }
        section.append(grid);stream.append(section);
      }

      const fieldRows=[],fieldSeen=new Set([Number(anchor.id)]),primaryExposures=new Set((plan.primary||[]).map(exposure)),fieldExposures=new Set();
      const pushField=p=>{
        if(!p||fieldRows.length>=4||fieldSeen.has(Number(p.id)))return;
        const exp=exposure(p);
        if(fieldExposures.has(exp))return;
        fieldSeen.add(Number(p.id));fieldExposures.add(exp);fieldRows.push(p);
      };
      (plan.world||[]).forEach(pushField);
      if(fieldRows.length<4){
        for(const rows of plan.alternatives.values()){
          for(const p of rows){
            if(primaryExposures.has(exposure(p)))continue;
            pushField(p);if(fieldRows.length>=4)break;
          }
          if(fieldRows.length>=4)break;
        }
      }
      if(fieldRows.length){
        const section=el('section','hs2-fe__section hs2-fe-products hs2-fe-products--field');section.dataset.intent='same-world';
        const head=el('div','hs2-fe__head'),copy=el('div','');
        copy.append(el('span','hs2-fe__eyebrow','KEŞFİ GENİŞLET'),el('h2','','Saha Sistemi'));
        head.append(copy);section.append(head);
        const grid=el('div','hs2-fe-grid');
        for(const p of fieldRows)grid.append(this.feProductCard(p,'same-world'));
        section.append(grid);stream.append(section);
      }

      const accessories=(plan.accessories||[]).slice(0,3);
      if(accessories.length){
        const section=el('section','hs2-fe__section hs2-fe-products hs2-fe-products--accessories');section.dataset.intent='accessory';
        const head=el('div','hs2-fe__head'),copy=el('div','');
        copy.append(el('span','hs2-fe__eyebrow','SAHADA TAMAMLA'),el('h2','','Saha Ekipmanı'));
        head.append(copy);section.append(head);
        const grid=el('div','hs2-fe-grid');for(const p of accessories)grid.append(this.feProductCard(p,'accessory'));section.append(grid);stream.append(section);
      }

      const substitutes=(plan.substitutes||[]).slice(0,4);
      if(substitutes.length){
        const section=el('section','hs2-fe__section hs2-fe-products hs2-fe-products--alternatives');section.dataset.intent='substitute';
        const head=el('div','hs2-fe__head');head.append(el('h2','','Alternatifler'));section.append(head);
        const grid=el('div','hs2-fe-grid');for(const p of substitutes)grid.append(this.feProductCard(p,'substitute'));section.append(grid);stream.append(section);
      }

      if(!reduced()&&'IntersectionObserver'in window){
        const motionSections=[...stream.querySelectorAll('.hs2-fe__section')];
        for(const section of motionSections){
          section.dataset.hsMotionPending='true';
          const staggerItems=[];
          if(section.classList.contains('hs2-fe-layer-map')){
            staggerItems.push(...section.querySelectorAll('.hs2-fe-layer'));
            staggerItems.push(...section.querySelectorAll('.hs2-fe-parallel__card'));
          }else{
            staggerItems.push(...section.querySelectorAll('.hs2-fe-grid > .hs2-fe-card'));
          }
          staggerItems.forEach((node,index)=>{
            node.dataset.hsStaggerItem='true';
            node.style.setProperty('--hs-stagger',Math.min(index,7)*58+'ms');
          });
        }
        this.fieldSectionObserver=new IntersectionObserver(entries=>{
          for(const entry of entries)if(entry.isIntersecting){
            delete entry.target.dataset.hsMotionPending;
            entry.target.dataset.hsEntered='true';
            this.fieldSectionObserver.unobserve(entry.target);
          }
        },{threshold:.12,rootMargin:'0px 0px -6% 0px'});
        for(const section of motionSections)this.fieldSectionObserver.observe(section);
      }
    }
    render(){
      if(this.cfg.setSystem){this.renderSystem();return;}
      this.renderFieldEditorial();
    }
    stickyLayout(){
      const sticky=document.querySelector('.hs-purchase-sticky');if(!sticky)return;
      const update=()=>{const r=sticky.getBoundingClientRect(),mobile=matchMedia('(max-width:749px)').matches;this.style.setProperty('--hs2-buy-safe',mobile?Math.ceil(Math.max(72,Math.min(180,r.height)))+8+'px':'8px');};
      update();this.stickyUpdate=update;window.addEventListener('load',update,{once:true});
      if('ResizeObserver'in window){this.stickyObserver=new ResizeObserver(update);this.stickyObserver.observe(sticky);}
      this.stickyMutation=new MutationObserver(update);this.stickyMutation.observe(sticky,{attributes:true,attributeFilter:['class','style']});

    }
    disconnectedCallback(){this.bootObserver?.disconnect();window.removeEventListener('pagehide',this.onPageHide);window.removeEventListener('pageshow',this.onPageShow);window.removeEventListener('load',this.stickyUpdate);this.stickyMutation?.disconnect();this.stickyObserver?.disconnect();this.momentObserver?.disconnect();this.fieldSectionObserver?.disconnect();this.fieldObserver?.disconnect();this.systemEditorialObserver?.disconnect();this.observer?.disconnect();this.liveObservers?.forEach(ro=>ro.disconnect());this.liveObservers?.clear();}
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs5-index"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const setup = (nav) => {
    if (nav.dataset.ready) return;
    nav.dataset.ready = '1';
    const list = nav.querySelector('.hs5-ix__list');
    const items = [...nav.querySelectorAll('[data-target]')].map((chip) => ({
      chip,
      el: document.querySelector('[id$="__' + chip.dataset.target + '"]')
    }));
    items.forEach((i) => { if (!i.el) i.chip.parentElement.hidden = true; });
    const live = items.filter((i) => i.el);
    const offset = () => (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0) + nav.offsetHeight;
    live.forEach(({ chip, el }) => chip.addEventListener('click', (e) => {
      e.preventDefault();
      scrollTo({ top: el.getBoundingClientRect().top + scrollY - offset() + 1, behavior: reduce() ? 'auto' : 'smooth' });
    }));
    let current = null, queued = false;
    const update = () => {
      queued = false;
      const line = offset() + 120;
      let next = null;
      live.forEach((i) => { if (i.el.getBoundingClientRect().top <= line) next = i; });
      if (next === current) return;
      current = next;
      live.forEach((i) => i.chip.toggleAttribute('aria-current', i === next));
      if (next && list.scrollWidth > list.clientWidth) list.scrollTo({ left: next.chip.offsetLeft - 16, behavior: reduce() ? 'auto' : 'smooth' });
    };
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    addEventListener('scroll', schedule, { passive: true });
    schedule();
  };
  const init = (root = document) => root.querySelectorAll('[data-hs5-ix]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs5-stage"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const sw = [...root.querySelectorAll('.hs5-st__swatch')];
    if (!sw.length) return;
    const $ = (s) => root.querySelector(s);
    const model = $('[data-st-model]'), flat = $('[data-st-flat]'), tag = $('[data-st-tag]');
    const text = { name: $('[data-st-name]'), price: $('[data-st-price]'), was: $('[data-st-was]'), save: $('[data-st-save]') };
    const cta = $('[data-st-cta]');
    const preload = (a) => { [a.dataset.model, a.dataset.flat].forEach((u) => { if (u) new Image().src = u; }); };
    let token = 0;
    const dots = $('[data-st-dots]');
    dots.innerHTML = sw.map(() => '<span></span>').join('');
    let cur = 0;
    const show = async (a, animate, dir) => {
      const mine = ++token;
      cur = sw.indexOf(a);
      [...dots.children].forEach((d, i) => d.classList.toggle('is-on', sw[i] === a));
      sw.forEach((s) => { if (s === a) s.setAttribute('aria-current', 'true'); else s.removeAttribute('aria-current'); });
      const out = a.classList.contains('is-out');
      text.name.textContent = a.dataset.name;
      text.price.textContent = a.dataset.price;
      text.was.textContent = a.dataset.was;
      text.save.textContent = a.dataset.save;
      tag.textContent = out ? 'Tükendi' : 'Stokta';
      tag.classList.toggle('is-out', out);
      cta.href = a.dataset.url;
      $('[data-st-fig]').setAttribute('aria-label', 'Seti incele: ' + a.dataset.name);
      root.style.setProperty('--disc', getComputedStyle(a).getPropertyValue('--c').trim());
      if (animate) { root.classList.add(dir ? (dir > 0 ? 'is-go-l' : 'is-go-r') : 'is-swap'); await new Promise((r) => setTimeout(r, 170)); }
      const pre = new Image(); pre.src = a.dataset.model;
      try { await pre.decode(); } catch (e) {}
      if (mine !== token) return;
      model.removeAttribute('srcset'); model.src = a.dataset.model; model.alt = a.dataset.name;
      flat.removeAttribute('srcset'); flat.src = a.dataset.flat;
      root.classList.remove('is-swap', 'is-go-l', 'is-go-r');
      if (dir) {
        /* yeni set kaydırmanın geldiği taraftan girer */
        root.classList.add(dir > 0 ? 'is-from-r' : 'is-from-l');
        void model.offsetWidth;
        root.classList.remove('is-from-r', 'is-from-l');
      }
      const next = sw[(sw.indexOf(a) + 1) % sw.length];
      if (next) preload(next);
    };
    const step = (d) => show(sw[(cur + d + sw.length) % sw.length], true, d);
    /* parmakla kaydırma: yalnız belirgin yatay hareket seti değiştirir */
    const fig = $('[data-st-fig]');
    let x0 = null, y0 = 0, t0 = 0, swiped = false;
    fig.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse' && e.button !== 0) return; x0 = e.clientX; y0 = e.clientY; t0 = Date.now(); });
    fig.addEventListener('pointerup', (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0, dy = e.clientY - y0, fast = Date.now() - t0 < 600;
      x0 = null;
      if (Math.abs(dx) > (fast ? 30 : 60) && Math.abs(dx) > Math.abs(dy) * 1.3) { swiped = true; step(dx < 0 ? 1 : -1); }
      /* kıpırdamadan dokunma: görünen setin sayfasını aç */
      else if (Math.abs(dx) < 10 && Math.abs(dy) < 10 && cta.href) window.location.href = cta.href;
    });
    fig.addEventListener('keydown', (e) => { if (e.key === 'Enter' && cta.href) window.location.href = cta.href; });
    fig.addEventListener('pointercancel', () => { x0 = null; });
    /* ilk ziyarette bir kez: manken hafifçe sola kayıp döner (kaydırılabildiğini gösterir) */
    if (sw.length > 1 && window.matchMedia('(pointer: coarse)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      let seen = false;
      try { seen = sessionStorage.getItem('hs5-st-nudge') === '1'; } catch (e) {}
      if (!seen) {
        const io = new IntersectionObserver((en) => {
          if (!en[0].isIntersecting) return;
          io.disconnect();
          setTimeout(() => { if (swiped) return; root.classList.add('is-nudge'); setTimeout(() => root.classList.remove('is-nudge'), 1200); }, 900);
          try { sessionStorage.setItem('hs5-st-nudge', '1'); } catch (e) {}
        }, { threshold: 0.6 });
        io.observe(fig);
      }
    }
    sw.forEach((a) => {
      a.addEventListener('click', (e) => {
        e.preventDefault();
        const to = sw.indexOf(a);
        if (to === cur) return;
        show(a, true, to > cur ? 1 : -1);
      });
      a.addEventListener('pointerenter', () => preload(a), { once: true });
      a.addEventListener('focus', () => preload(a), { once: true });
    });
    show(sw.find((s) => s.getAttribute('aria-current') === 'true') || sw[0], false);
  };
  const init = (root = document) => root.querySelectorAll('[data-hs5-st]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs5-tabs"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const all = root.querySelector('[data-tabs-all]');
    const panel = (tab) => document.getElementById(tab.getAttribute('aria-controls'));
    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        const p = panel(t);
        if (p) p.hidden = !on;
      });
      if (all && tab.dataset.url) all.href = tab.dataset.url;
      if (focus) tab.focus();
      tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', (e) => {
        const to = { ArrowRight: (i + 1) % tabs.length, ArrowLeft: (i - 1 + tabs.length) % tabs.length, Home: 0, End: tabs.length - 1 }[e.key];
        if (to === undefined) return;
        e.preventDefault();
        select(tabs[to], true);
      });
    });
  };
  const init = (root = document) => root.querySelectorAll('[data-hs5-tabs]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

  } catch(e) { console.error(e); }
})();
})();
